export default {
  domainDirectory: {
    title: "النطاقات الرسمية", subtitle: "تحقق من العناوين الرسمية هنا. اضغط لنسخ العنوان.", available: " متصل حاليًا",
    loading: "جارٍ تحميل النطاقات…", loadFailed: "تعذر تحميل النطاقات", retry: "إعادة التحميل", empty: "لا توجد نطاقات نشطة",
    tapToCopy: "اضغط للنسخ", checking: "جارٍ الفحص", checkingShort: "جارٍ الفحص", online: "متصل", offline: "انتهت مهلة الاتصال",
    waiting: "بانتظار الفحص", timeout: "انتهت المهلة", testAll: "اختبار جميع النطاقات الآن", updatedEveryFifteenSeconds: "يتم فحص الاتصال تلقائيًا كل 15 ثانية",
    saveReminder: "التقط صورة لهذه الصفحة للاحتفاظ بمعلومات النطاقات", copied: "تم نسخ النطاق",
    names: { primary: "النطاق الرئيسي", chinaAccel: "تسريع الصين", secondary: "نطاق ثانوي" },
  },
  nickname: {"edit": "تعديل اللقب", "hint": "٢–٢٠ حرفًا صينيًا/إنجليزيًا أو أرقامًا أو _", "saved": "تم حفظ اللقب", "taken": "هذا اللقب مستخدم بالفعل", "invalid": "استخدم ٢–٢٠ حرفًا صينيًا/إنجليزيًا أو أرقامًا أو _. الأسماء المحجوزة غير مسموحة.", "failed": "تعذر الحفظ. حاول مرة أخرى."},
  common: {
    confirm: "تأكيد",
    cancel: "إلغاء",
    search: "بحث",
    language: "اللغة",
    pleaseRelogin: "انتهت الجلسة، يرجى تسجيل الدخول مجددًا",
    developing: "الميزة قيد التطوير",
    switched: "تم التبديل",
    currentLanguage: "اللغة الحالية",
    selectLanguage: "اختر اللغة",
    loading: "جارٍ التحميل...",
    loadingMore: "جارٍ تحميل المزيد...",
    noMoreData: "لا مزيد من البيانات",
    noData: "لا توجد بيانات",
    serverUnavailable: "الخادم غير متاح مؤقتًا",
    loadFailed: "فشل التحميل",
    requestFailed: "فشل الطلب",
    retry: "انقر لإعادة المحاولة",
    projectName: "PANTA MARKET",
    duplicateSubmission: "الرجاء عدم الإرسال مرة أخرى",
    fee: "رسوم",
    submit: "إرسال",
    tip: "تنبيه",
    connecting: "جارٍ الاتصال...",
    connectWalletFirst: "يرجى ربط المحفظة أولاً",
    connect: "ربط",
    insufficientBalance: "الرصيد غير كافٍ",
    copyFailed: "فشل النسخ",
    sessionAuthRelogin: "تسجيل الدخول مجددًا",
    sessionAuthStay: "البقاء",
    pager: {
      prevPage: "السابق",
      nextPage: "التالي",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "الانتقال إلى",
      jumpConfirm: "اذهب",
    },
  },
  tabbar: {
    home: "Home",
    market: "Timeline",
    timeline: "Timeline",
    prediction: "توقع عقد أحداث الذكاء الاصطناعي",
    createMarket: "إنشاء سوق",
    planet: "Planet",
    trade: "AI Prediction",
    finance: "Finance",
    fund: "صندوق",
    assets: "Assets",
    planethistory: "History"
  },
  tradeMenu: {
    contract: "Event Contract",
    insurance: "Insurance",
    spot: "Spot",
    flash: "Flash Swap"
  },
  home: {
    searchPlaceholder: "BTC",
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "تنبؤ بالذكاء · عقود الأحداث · تحليل ذكي",
    predictionCategories: {
      hot: "Timeline",
      sports: "Sports",
      world: "World",
      politics: "Politics",
      economy: "Economy"
    },
    predictionSubCategories: {
      crypto: "Spot",
      forex: "Forex",
      commodities: "Commodities"
    },
    features: {
      recharge: "Recharge",
      rechargeDesc: "Quick deposit",
      contract: "Event Contract",
      contractDesc: "Innovative financial tools",
      predict: "AI Prediction",
      fund: "PANTA MARKET Treasury",
      invite: "Invite Friends",
      global: "Global Nodes"
    },
    insurance: {
      title: "Contract Insurance Pool (TAKER)",
      aiPoolTitle: "مجمع تأمين الذكاء الاصطناعي",
      ordinaryPoolTitle: "مجمع قيمة التأمين العادي",
      approxUsdt: "≈ {amount} U",
      approxPantaRef: "≈ {amount} PANTA (مرجعي)",
      more: "Learn More",
      yesterday: "Added Yesterday",
      service: "Smart Service"
    },
    market: {
      tabs: {
        main: "Main",
        hot: "Hot",
        rise: "Gainers",
        price: "Price"
      },
      headers: {
        pair: "Pair",
        latest: "Latest Price",
        change: "24h Change"
      },
      viewMore: "View More",
      collapse: "Collapse"
    },
    announcement: {
      title: "إعلان",
      heading: "إعلان",
      text: "Welcome to PANTA MARKET. Explore event contracts, AI insights, and protection tools for prediction markets. Here, you will experience the unique AI and prediction insurance system created by PANTA MARKET, allowing you to easily join the WEB3 prediction market and start your journey to wealth.",
      time: "2025/11/19 10:00",
      gotIt: "حسنًا",
      viewDetail: "عرض التفاصيل",
      systemLabel: "إعلان النظام"
    },
    timePeriods: {
      "1min": "دقيقة واحدة",
      "30min": "30 دقيقة",
      "1hour": "ساعة واحدة"
    },
    footer: {
      australia: "· Australia",
      uae: "· United Arab Emirates",
      attention: "· ATTENTION:",
      attentionText: "PANTA MARKET is operated by the platform itself. We do not authorize any third party to collect fees in our name. We do not authorize any third party to collect fees in any form or name. For inquiries, please contact official customer service at: {email}"
    },
    timeframes: {
      "1s": "1 دقيقة",
      "1m": "1 دقيقة",
      "5m": "5 دقائق",
      "15m": "15 دقيقة",
      "1h": "ساعة",
      "4h": "4 ساعات",
      "1d": "يوم"
    },
    statusHotEn: "HOT",
    yes: "نعم",
    no: "لا",
    hotBannerTitle: "عقد الحدث",
    homeBanner: {
      s1t1: "مدعوم بالذكاء الاصطناعي",
      s1t2: "منظومة AstralX الأساسية",
      s1cta: "AstralX",
      s2t: "صندوق Galaxy",
      s2s1: "تعرّف على حماية رأس المال",
      s2s2: "وقواعد التوزيع",
      s2cta: "الاشتراك",
      s3s: "توقع السعر",
      s3cta: "توقّع",
    },
    catCrypto: "عملات رقمية",
    catMetal: "معادن",
    catSports: "رياضة",
    catPolitics: "سياسة",
    catEntertainment: "ترفيه",
    statusHot: "رائج",
    statusLocked: "مقفل",
    statusLive: "مباشر",
    statusLockedWait: "مقفل بانتظار التسوية",
    jouleUnit: "JOULE",
    nowLabel: "الآن",
    endAtFallback: "--",
    predictionLabel: "Prediction",
    rise: "Up",
    fall: "Down",
    viewMoreOptions: "عرض {n} خيارات إضافية",
    categoryAll: "الكل",
    categoryCrypto: "العملات المشفرة",
    categoryEquity: "الأسهم",
    categoryCommodity: "السلع",
    categoryForex: "فوركس",
    categoryMetal: "المعادن"
  },
  withdraw: {
    title: "Withdraw",
    headerTitle: "Withdraw",
    address: "Withdrawal Address",
    addressLabel: "Withdrawal Address",
    addressPlaceholder: "Enter or paste address",
    network: "Network",
    selectNetwork: "Select Network",
    networkHint: "Please ensure the withdrawal address matches the selected network",
    withdrawAmount: "Withdraw Amount",
    receiveAmount: "Receive Amount",
    networkFee: "Network Fee",
    submit: "Confirm Withdrawal",
    submitButton: "سحب",
    balance: "Balance",
    all: "All",
    amountPlaceholder: "Please enter",
    minimumWithdrawal: "Minimum withdrawal amount: {amount} USDT",
    minimumWithdrawalTAKER: "Minimum withdrawal amount: {amount}TAKER",
    fee: "Fee",
    confirm: "Confirm",
    confirmTitle: "Confirm Action",
    confirmContent: "Are you sure you want to proceed?",
    toasts: {
      fetchFailed: "Failed to fetch assets",
      enterAddress: "Please enter a withdrawal address",
      enterValidAmount: "Please enter a valid withdrawal amount",
      insufficientBalance: "Insufficient balance",
      minimumAmount: "Minimum withdrawal amount is {amount} USDT",
      processing: "Processing...",
      success: "Withdrawal successful!",
      requestSuccess: "Withdrawal request successful",
      requestFailed: "Withdrawal failed, please try again",
      notConfigured: "Withdrawals are not available yet"
    },
    addressHint: "Withdrawal will be sent to your wallet address"
  },
  deposit: {
    headerTitle: "Deposit",
    connectPrompt: "Please connect your wallet to deposit",
    loading: "Loading...",
    depositAddress: "Deposit Address",
    minimumDeposit: "*Minimum deposit 10.0000 USDT",
    depositAmount: "Deposit Amount",
    balance: "Balance",
    amaBalance: "JOULE Balance",
    amount: "Amount",
    amountPlaceholder: "Enter deposit amount",
    minimumNotice: "*الحد الأدنى {min} {token}",
    processing: "Processing...",
    confirm: "Confirm Deposit",
    confirmTitle: "Confirm Action",
    confirmContent: "Are you sure you want to proceed?",
    helpText: "Deposit will call the smart contract recharge method, TAKER token approval required",
    toasts: {
      copySuccess: "Copied successfully",
      dataLoadFailed: "Failed to load data",
      enterValidAmount: "Please enter a valid deposit amount",
      invalidAmount: "Deposit amount cannot be less than {min} TAKER",
      invalidAddress: "Invalid deposit address",
      checkingAllowance: "Checking allowance...",
      approving: "Approving...",
      approveSuccess: "Approval successful",
      depositing: "Depositing...",
      depositSuccess: "Deposit successful",
      depositFailed: "Deposit failed",
      balanceLoadFailed: "تعذر قراءة رصيد USDT التجريبي. حدّث الصفحة وحاول مجددًا",
      contractError: "Contract call failed, please check balance",
      userCancelled: "You have cancelled the operation",
      insufficientFunds: "Insufficient balance",
      wrongNetwork: "Please switch to the correct network",
      requestingAuth: "Requesting wallet authorization...",
      waitingConfirmation: "Waiting for transaction confirmation...",
      transactionFailed: "Transaction initiation failed",
      transactionCancelled: "You have cancelled the transaction",
      genericError: "Transaction failed",
      configNotReady: "Deposits are not available yet",
      invalidTxHash: "Please enter a valid transaction hash",
      claimPending: "Deposit submitted, credit pending",
      cannotGetBalance: "Cannot get balance, please refresh and try again"
    },
    depositNotice: "Please transfer to the following address, the system will process automatically after arrival",
    usdtBalance: "USDT Balance"
  },
  team: {
    headerTitle: "My Team",
    contractEarnings: "My Contract Earnings",
    btcFund: "عوائد التمويل",
    stats: {
      teamSubscribed: "رهن الفريق",
      personalSubscribed: "رهن شخصي",
      totalTeam: "حجم الفريق",
      periodTeam: "أرباح الفريق",
      periodPersonal: "حجم شخصي",
      personalEarnings: "أرباح شخصية متراكمة",
      teamEarnings: "أرباح الفريق",
      personalVolume: "حجم شخصي",
      teamVolume: "حجم الفريق",
      personalPower: "Personal Power",
      teamTotalPower: "Team Total Power"
    },
    links: {
      invite: "Invite Friends",
      details: "Team Details"
    },
    inviteBannerTitle: "Invite Friends to Unlock Team Commissions",
    inviteBannerSubtitle: "Unlock your team commissions",
    inviteBannerCta: "Join Now",
    unclassifiedHint: "مصدر دفعات سابقة بانتظار المراجعة: {amount} {asset}"
  },
  my: {
    headerTitle: "My",
    login: "Tap to Login",
    inviteCode: "Invite Code:",
    groups: {
      common: "Common Features",
      trading: "Trading",
      finance: "Finance",
      help: "Help"
    },
    features: {
      invite: "Invite Friends",
      team: "My Team",
      insurance: "Event Contract Insurance",
      contract: "Event Contract",
      exchange: "Exchange",
      fund: "AI Treasury Fund",
      communitySquare: "ساحة المجتمع",
      createEvent: "إنشاء حدث",
      community: "Official Community",
      terms: "Terms of Service",
      announcement: "Announcements",
      privacy: "Privacy Policy",
      aboutUs: "من نحن"
    }
  },
  community: {
    title: "المجتمع الرسمي",
    bannerTitle1: "انضم إلى مجتمعنا",
    bannerTitle2: "تواصل مع المستخدمين العالميين",
    linkCopied: "تم نسخ الرابط"
  },
  invite: {
    headerTitle: "Invite Friends",
    rulesEntry: "Invite Rules",
    subtitle: "Earn from every team trade",
    mainTitle: "Invite & Earn",
    description: "Share the link — friends trade, you get rewards",
    yourCode: "Your Invite Code",
    shareLink: "Share Link",
    inviteButton: "Invite Friends",
    subTitle: "Get High Commissions",
    viewRules: "View Rules",
    rulesLink: "View Referral Rules >",
    rulesTitle: "Referral Rules",
    rules: {
      commissionTable: {
        title: "PANTA MARKET Trading Volume Commission Table",
        headers: {
          level: "Level",
          personalTurnover: "Personal Vol",
          teamTurnover: "Team Vol",
          commission: "Team Comm"
        }
      }
    },
    inviteBoxTitle: "Invite Friends",
    referralCode: "Referral Code",
    inviteLink: "Invitation Link",
    loading: "Loading...",
    copyButton: "Copy Invitation Link",
    toasts: {
      emptyContent: "Content is empty",
      copySuccess: "Copied successfully",
      bindSuccess: "Bound successfully",
      bindFailed: "فشل الربط",
      alreadyBound: "Superior already bound; cannot change",
      loginFirst: "Please connect wallet first",
      invalidCode: "Please enter a valid invite code or wallet address",
      cannotBindSelf: "Cannot bind yourself",
    },
    boundLabel: "تم ربط الأعلى",
    modalDesc: "لم يتم ربط الأعلى بعد. أدخل رمز الدعوة أو عنوان المحفظة للمشاركة في مكافآت الفريق. تُملأ بيانات الرابط تلقائياً؛ وإلا يُملأ عنوان الأعلى الافتراضي مسبقاً.",
    bindPlaceholder: "أدخل رمز الدعوة أو عنوان المحفظة",
    bindButton: "ربط",
    binding: "جارٍ الربط…",
    bindSuperior: "ربط الأعلى",
  },
  finance: {
    title: "Finance page is under development..."
  },
  wealthAccess: {
    exchangeThresholdFailed: "فشل التحويل: لم تُستوفَ المتطلبات",
    internalPrice: "السعر الداخلي",
    marketPrice: "سعر السوق",
    coinBasis: "مقوّم بالعملة",
    legacyBasis: "مقوّم بالعملة",
    contractBasis: "أساس التسوية",
    unitPrice: "سعر وحدة الشراء",
    quotaUsed: "إجمالي الشراء بالسعر الداخلي",
    quotaRemaining: "الحصة الداخلية المتبقية",
    quotaHint: "الحد مدى الحياة {limit} PANTA عبر جميع الخطط. إيقاف السعر أو الاستحقاق أو تغيير VIP لا يصفر الإجمالي.",
    principal: "أصل المبلغ",
    principalReturn: "الأصل المعاد عند الاستحقاق",
    dailyYield: "العائد الإجمالي اليومي",
    coinYieldHint: "العائد اليومي = أصل PANTA × المعدل السنوي ÷ 360 مع التقريب لأسفل بأصغر وحدة. تغير السعر لا يغير عملات العقد. التوزيع وفق القواعد المعمول بها.",
    legacyHint: "عقد مقوّم بالعملة. يتم تحويل سداد الأصل إلى PANTA بسعر الاستحقاق المحدد بالعقد.",
    quotaError: "تم تجاوز الحصة الداخلية. قلل الكمية؛ لا يتم تقسيم الطلب أو التحويل لسعر السوق تلقائياً.",
    permissionChanged: "الخطة لم تعد متاحة لمستوى VIP الحالي. تم تحديث القائمة.",
    quoteChanged: "تغير السعر أو الأهلية. راجع العرض الجديد وأكد مجدداً.",
    quoteExpired: "انتهى العرض. حدثه وراجعه قبل التأكيد.",
    retryQuote: "تحديث العرض",
    stakeGateTitle: "شرط التحصيص لبيع PANTA",
    stakeGateBody: "VIP{vip}: التحصيص الفعال {staked} PANTA؛ المطلوب {required} PANTA؛ النقص {shortfall} PANTA. القيد للبيع فقط ولا يؤثر في الشراء.",
    goStake: "الذهاب للتحصيص",
    refreshEligibility: "تحديث الأهلية",
  },
  fundPage: {
    heroTitle: "توزيع عوائد PANTA يوميًا",
    heroDesc: "اشترك في صندوق Galaxy للحصول على أرباح سنوية",
    learnMore: "اعرف المزيد",
    allProducts: "جميع المنتجات",
    subscribe: "اشتراك",
    stake: "رهن",
    stakePreview: "معاينة الرهن",
    searchCoin: "بحث عن عملة",
    allPeriods: "كل المدد",
    colCoin: "اسم الصندوق",
    colApy: "عائد سنوي بالعملة",
    colTerm: "المدة",
    fixedTerm: "ثابت",
    galaxyProduct: "Galaxy {n}",
    termLabel: "المدة",
    apyLabel: "العائد السنوي",
    stakeCap: "الحيازات الشخصية",
    stakeAmount: "مبلغ الرهن",
    estEarnings: "أرباح متوقعة",
    stakeDisclaimer: "العائد توضيحي وغير مضمون. يُوزَّع نحو 70٪ إلى الرصيد المتاح و30٪ إلى أموال التجربة؛ تُفتح أموال التجربة بعد دوران يقارب 3 أضعاف.",
    stakeSuccess: "تم الرهن بنجاح",
    annualized: "عائد سنوي مرجعي",
    perShareYield: "عائد / 10 آلاف (WBS)",
    dayUnit: "ي",
    empty: "لا توجد منتجات صندوق بعد",
    loadFailed: "فشل التحميل",
    rulesTitle: "معلومات الصندوق",
    gotIt: "حسناً",
    pantaAvailable: "PANTA المتاح",
    activeFaceValue: "الحصص النشطة",
    totalReward: "أرباح الصندوق المتراكمة (PANTA)",
    fundYieldUnavailable: "--/يرجى تحديث الخدمة",
    effectiveVip: "المستوى الساري",
    myHoldings: "سجل شراء الصندوق",
    faceValue: "القيمة",
    maturity: "الاستحقاق",
    stakeStart: "وقت الرهن",
    pantaPrice: "سعر PANTA",
    noMoreHoldings: "لا مزيد من الحيازات",
    subscriptionStatus: {
      ACTIVE: "نشط",
      SETTLED: "تمت التسوية",
      CANCELLED: "ملغى",
      MANUAL_REVIEW: "مراجعة يدوية",
    },
    minPanta: "الحد الأدنى PANTA",
    pantaAmount: "كمية الاشتراك (PANTA)",
    stepHint: "مضاعف لـ {step}، الحد الأدنى {min}",
    getQuote: "الحصول على عرض سعر",
    confirmStake: "تأكيد الرهن",
    jouleDebit: "خصم JOULE",
    expectedPanta: "PANTA المرهون",
    quoteExpires: "صلاحية العرض حتى",
    unavailable: "غير متاح حالياً",
    invalidAmount: "أدخل كمية PANTA وفق الخطوة الصحيحة",
    quoteFailed: "فشل عرض السعر",
    rewards: "مكافآت الصندوق",
    unlock: "دفعات تجميد PANTA",
    unlockProgress: "حجم التداول المستخدم",
    pantaLedger: "دفتر PANTA"
  },
  finanfund: {
    title: "PANTA MARKET Treasury Fund",
    subtitle: "Simple, Efficient, Easy Earnings",
    productName: "PANTA MARKET Treasury Fund",
    minAmount: "Min Amount",
    incomeRatio: "Income Ratio",
    lockPeriod: "Lock Period",
    dailyReturn: "Daily Return",
    earning: "Earned",
    redemptionRules: "Redemption Rules",
    rules: {
      rule1: "PANTA MARKET Treasury Fund cannot be redeemed after custody",
      rule2: "Daily earnings are automatically credited",
      rule3: "Locked amount will be returned after the lock period ends"
    },
    subscription: "Subscribe",
    amountPlaceholder: "Enter amount",
    balance: "Balance",
    availableFunds: "Available Funds",
    all: "All",
    subscribeButton: "Subscribe",
    toasts: {
      productIdNotExist: "Product ID does not exist",
      enterValidAmount: "Please enter a valid subscription amount",
      minAmountRequired: "Subscription amount cannot be less than {amount} USDT",
      subscribeSuccess: "Subscription successful",
      subscribeFailed: "Subscription failed"
    }
  },
  assets: {
    insuranceFrozen: "حد التأمين المجمد (JOULE)",
    available: "Available",
    deposit: "Deposit",
    withdraw: "Withdraw",
    myAccountRecords: "My Account Records",
    nodeEquityHint: "Node equity valued in USDT, not a cash deposit",
    nodeEquityRate: "Applied rate: {rate}%",
    nodeEquitySources: {
      PERSONAL: "Personal insurance equity",
      TEAM: "Team insurance equity",
      ADMIN: "Platform Airdrop",
      AI_INSURANCE: "AI insurance node equity payout",
      BACKFILL: "AI insurance node equity backfill",
      OTHER: "Node equity credited",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "Node equity credited",
      BET_STAKE: "تجميد الرهان",
      WIN_PAYOUT: "ربح التداول",
      LOSS_SETTLEMENT: "خسارة التداول",
      REFUND: "استرداد",
      INSURANCE_PREMIUM: "مصروف القسط",
      INSURANCE_PAYOUT: "تعويض التأمين",
      INSURANCE_TRANSFER_IN: "تحويل وارد للتأمين",
      INSURANCE_TRANSFER_OUT: "تحويل صادر من التأمين",
      NETWORK_DIFFERENTIAL: "مكافأة الفارق",
      NETWORK_PEER: "مكافأة المستوى المماثل",
      NETWORK_UNLOCK: "تحرير الأرباح",
      EVENT_INSURANCE_PAYOUT: "تعويض عقدة القدرة",
      EVENT_INSURANCE_PEER: "مكافأة المستوى المماثل للقدرة",
      TRANSFER_IN: "تحويل وارد",
      TRANSFER_OUT: "تحويل صادر",
      PREMIUM_LOCK: "قفل القسط",
      PREMIUM_SETTLE: "مصروف القسط",
      PREMIUM_REFUND: "استرداد القسط",
      WEALTH_SUBSCRIPTION: "اكتتاب الصندوق",
      SUBSCRIPTION_LOCK: "قفل التخزين",
      WEALTH_DAILY_REWARD: "فائدة الصندوق اليومية",
      WEALTH_TEAM_REWARD: "مكافأة فريق الصندوق",
      MATURITY_RELEASE: "إعادة رأس المال عند الاستحقاق",
      WEALTH_UNLOCK: "تحرير الأرباح",
      COPY_SHARE_HOLD: "Copy share held",
      COPY_SHARE_RELEASE: "Copy share unfrozen / refunded",
      COPY_SHARE_PAYOUT: "Copy share paid out",
      COPY_TRADE_TRANSFER_OUT: "Transfer to copy account",
      COPY_TRADE_TRANSFER_IN: "Transfer from copy account",
      COPY_WIN_PAYOUT: "Copy profit",
      COPY_LOSS_SETTLEMENT: "Copy loss",
      COPY_TRANSFER_IN: "Deposit to copy account",
      COPY_TRANSFER_OUT: "Withdraw from copy account",
      COPY_SHARE_PAYOUT_IN: "Copy share received",
      COPY_SHARE_POOL_IN: "Copy share pool in",
      COPY_SHARE_POOL_REFUND: "Copy share pool refund",
      COPY_SHARE_POOL_MIGRATION: "Copy share pool migration",
      COPY_FLOW: "Copy trade record"
    },
    recordCategories: {
      NODE_EQUITY: "Node equity",
      TRADE_PNL: "أرباح/خسائر التداول",
      PREMIUM: "القسط",
      INSURANCE_PAYOUT: "تعويض التأمين",
      TEAM_REWARD: "مكافأة الفريق",
      COPY: "Copy Details",
      COPY_TRADE_PNL: "Copy P&L",
      COPY_SHARE: "Copy share",
      COPY_TRANSFER: "Copy transfer",
      WEALTH_REWARD: "فائدة الصندوق",
      UNLOCK: "تحرير",
      PRINCIPAL: "اكتتاب/إعادة رأس المال",
      TRANSFER: "تحويل داخلي"
    },
    amountPendingReview: "المبلغ بانتظار المراجعة",
    creditedSplit: "متاح {available} · مجمّد {frozen}",
    creditedSplitPending: "التقسيم بانتظار المراجعة",
    afterBalance: "بعد التغيير: متاح {available} · مجمّد {frozen}",
    unlockHint: "مجمّد → متاح؛ ليست أرباحاً جديدة",
    transferFromInsurance: "حساب التأمين",
    transferFromMain: "الحساب الرئيسي",
    all: "All",
    transfer: "Transfer",
    insuranceDeduction: "Insurance Deduction",
    insurancePayout: "Insurance Payout",
    noRecords: "No records",

    actions: {
      deposit: "Deposit",
      withdraw: "Withdraw",
      exchange: "Exchange",
      transfer: "Transfer"
    },
    loginPrompt: {
      text: "Please connect your wallet first",
      button: "Connect"
    },
    toasts: {
      connectFailed: "Connection failed, please try again"
    },
    pantaUsdtRate: "1 PANTA = {price} USDT",
    buyNodeModal: {
      title: "Buy Trading Node",
      cancel: "Cancel Purchase",
      purchasing: "Purchasing...",
      confirm: "Confirm Purchase",
      availableBalance: "Available Balance",
      unavailable: "Not available yet",
      description: "Pay {amount}JOULE to get trading node access",
      insufficient: "Insufficient balance, please deposit first",
      success: "Purchase successful",
      failed: "Purchase failed, please retry"
    },
    transferToMain: "Transfer to Main System",
    mainSystemPanta: "Main System (PANTA)",
    jouleAvailable: "JOULE Available",
    detailTitle: "Asset Details",
    totalAssetsUsdt: "Estimated Total Value (USDT)",
    jouleConvert: "JOULE Converted (× rate)",
    usdtPart: "USDT Portion",
    totalSum: "Total",
    tradeFrozen: "Trade Frozen (JOULE)",
    financeReleaseFrozen: "Finance Release Frozen (JOULE)",
    insuranceAccountJoule: "Insurance (JOULE)",
    usdtAvailableLabel: "USDT Available",
    usdtFrozenLabel: "USDT Frozen",
    noHoldings: "No holdings yet",
    availableAssets: "Available Assets",
    tradeFrozenJoule: "Trade Frozen (JOULE)",
    payoutPower: "Compute Node Payout",
    payoutEquity: "AI Prediction Payout (JOULE)",
    mainAccount: "التداول",
    insuranceAccountShort: "التأمين",
    copyAccountShort: "النسخ",
    tradingAccountHelpTitle: "Trading account balance",
    copyAvailableLabel: "Available",
    copyFrozenLabel: "Frozen",
    copyAccountJoule: "حساب النسخ (JOULE)",
    copyTotalPnl: "PnL النسخ",
    transferSheet: {
      title: "تحويل",
      pairCopy: "تداول / نسخ",
      pairInsurance: "تداول / تأمين",
      tradingAccount: "حساب التداول",
      copyAccount: "حساب النسخ",
      insuranceAccount: "حساب التأمين",
      jouleHint: "تحويلات JOULE فقط",
      submit: "إرسال",
      transferring: "جاري التحويل...",
      success: "تم التحويل بنجاح",
      failed: "فشل التحويل، أعد المحاولة",
    },
    computeNode: "Compute Nodes",
    stakedTotalPanta: "Fund Staked",
    stakedPlusRewardPanta: "Stake + Est. Earnings",
    stakedPlusRewardTipTitle: "Stake principal + estimated earnings",
    stakedPlusRewardTip:
      "This amount is staked principal plus estimated total earnings.",
    stakedPrincipalLabel: "Stake principal",
    stakedExpectedYieldLabel: "Estimated earnings",
    annualEarningsPanta: "Fund Earnings",
    frozenTotalPanta: "Total Frozen",
    unlockedTotalPanta: "Total Unlocked",
    fundTeamPendingPanta: "أرباح فريق الصندوق المعلقة (PANTA)",
    fundTeamPaidPanta: "أرباح فريق الصندوق المدفوعة (PANTA)",
    pendingRewardPanta: "Pending Airdrop",
    paidRewardPanta: "Airdropped",
    expectedAirdropQuota: "Estimated Pending Airdrop",
    cumulativeAirdropValue: "قيمة التوزيعات التراكمية: {value} USDT",
    roundProgress: "Node Generation Progress",
    currentNodeCount: "Current Nodes",
    roundExpectedValue: "Est. this round: {value} USDT",
    historyTotalValue: "Historical total: {value} USDT",
    nextAirdropAt: "Next distribution: {time}",
    airdropEstimateUnavailable: "Unable to estimate",
    roundExpectedValueUnavailable: "Est. this round: unable to estimate",
    airdropEstimateHint: "Estimate only; actual settlement prevails",
    invalidNodeCount: "Invalid Nodes",
    deductedNodeCount: "Deducted Nodes",
    todayRelease: "Today Release",
    releaseFrozenPanta: "Release Frozen",
    unlockQuota: "Unlock Quota",
    unlockQuotaNote: "Today unlockable 0.0000",
    tradeNode: "Trade Node",
    tradeNodeDesc: "Upgrade to VIP3 and unlock trading benefits",
    tradeNodeHint: "Price: 2888 JOULE · Upgrade to VIP3",
    buyNode: "Buy Node",
    insuranceAccountRecordsShort: "Insurance"
  },

  wallet: {
    title: "My Wallet",
    address: "Wallet Address",
    addressCopied: "Address copied",
    inviteCode: "Invite Code",
    logout: "Logout",
    login: "Login",
    toasts: {
      networkSwitchCancelled: "Network switch cancelled by user",
      networkConfigNotFound: "Network configuration not found for {chainId}",
      signatureCancelled: "Signature cancelled by user",
      connectionFailed: "Failed to Connect",
      accountSwitched: "Wallet account switched, please reconnect",
      connectionTimedOut: "Connection timed out, please try again",
      loginSuccess: "Login successful",
      logoutSuccess: "Logged out successfully",
      switchNetwork: "Please switch to {chainName} in your wallet before trying to deposit",
      wrongChain: "Unsupported network, please switch to {chainName}",
      switchingNetwork: "Switching network...",
      switchNetworkFailed: "Network switch failed, please manually switch to {chainName} in your wallet"
    }
  },
  market: {
    title: "Market",
    banner: {
      title: "Event Contract",
      desc: "Unlock the earning potential on-chain"
    },
    tabs: {
      main: "Mainstream",
      rise: "Top Gainers"
    },
    types: {
      crypto: "Cryptocurrency",
      stocks: "Stocks",
      forex: "Forex",
      commodities: "Commodities",
      favorites: "Favorites"
    },
    headers: {
      pair: "Pair",
      price: "Last Price",
      change: "Daily Change"
    },
    loading: "Loading...",
    loadingMore: "Loading more...",
    noMoreData: "No more data"
  },
  notice: {
    loginRequired: "Please log in to view announcements",
    empty: "No announcements yet",
    unpublished: "Unpublished",
    title: "Announcements",
    helpCenter: "Help Center",
    noticeDetail: "Notice Detail",
    viewDetail: "View Details",
    pdfViewer: "PDF Viewer",
    videoPlayer: "Video Player",
    imageViewer: "Image Viewer",
    documentViewer: "Document Viewer",
    clickToViewPdf: "Click to view PDF",
    clickToViewDocument: "Click to view document",
    openInBrowser: "Open in Browser",
    tryingViewer: "Trying viewer {current}/{total}",
    pdfLoadFailed: "PDF preview failed, please download to view",
    downloadPdf: "Download PDF",
    defaultCategory: "Notice"
  },
  trade: {
    title: "Event Contract",
    nextRound: "Next Round",
    posCurrent: "Current",
    aiThenPrefix: 'AI then: ',
    aiUnlinked: 'No linked AI',
    aiNotRecorded: 'Not recorded',
    insuranceLabel: "Insurance",
    insuranceNotSelected: 'غير محدد',
    insuranceInactive: "غير سارٍ",
    insuranceTypeNone: "غير سارٍ",
    insuranceTypeEvent: "تأمين الحدث مفعّل",
    insuranceTypeEventShort: "تأمين الحدث",
    insuranceTypeAi: "تأمين الذكاء الاصطناعي مفعّل",
    insuranceTypeAiShort: "تأمين الذكاء الاصطناعي",
    insuranceTypeConverted: "تم تحويل هذا الأمر إلى تأمين عادي",
    insuranceTypeUnknown: "حالة التأمين بانتظار التأكيد",
    inProgress: "In Progress",
    estimatedPnl: "الربح والخسارة التقديرية",
    settlementConfirming: "جارٍ تأكيد النتيجة",
    balanceSyncing: "جارٍ مزامنة الرصيد",
    pendingReview: "بانتظار المراجعة",
    connecting: "Connecting...",
    connectWallet: "Connect",
    orderDetail: {
      title: "تفاصيل الطلب",
      orderId: "رقم الطلب",
      symbol: "الزوج",
      interval: "الفترة",
      direction: "الاتجاه",
      aiDirection: "الذكاء الاصطناعي حينها",
      openTime: "وقت الفتح",
      settleTime: "وقت الانتهاء",
      settledAt: "وقت التسوية",
      openPrice: "سعر الفتح",
      closePrice: "سعر الإغلاق",
      stake: "الأصل",
      premium: "القسط",
      netProfit: "صافي الربح/الخسارة",
      status: "الحالة",
      orderSource: "مصدر الطلب",
      converted: "تحويل التأمين",
      notRecorded: "غير مسجل",
      copied: "تم نسخ رقم الطلب",
    },
    orderStatus: {
      CREATED: "تم الإنشاء",
      ACCEPTED: "مقبول",
      CLOSED: "مغلق",
      FUNDS_LOCKED: "الأموال مقفلة",
      AWAITING_SETTLEMENT: "بانتظار التسوية",
      PROCESSING: "قيد المعالجة",
    },
    insuranceBalanceInsufficient: "رصيد حساب التأمين غير كافٍ",
    mainBalanceInsufficient: "رصيد الحساب الرئيسي غير كافٍ",
    insuranceBalanceRequired: "رصيد حساب التأمين غير كافٍ؛ لا يمكن تفعيل التأمين",
    insuranceRulesUnavailable: "قواعد القسط غير جاهزة؛ لا يمكن تفعيل التأمين",
    insuranceMainRequired: "رصيد الحساب الرئيسي غير كافٍ؛ لا يمكن تفعيل التأمين",
    preferenceLoading: "جارٍ تحميل إعدادات التأمين",
    preferenceLoadFailed: "فشل تحميل إعدادات التأمين؛ انقر لإعادة المحاولة",
    preferenceSaveFailed: "فشل حفظ إعدادات التأمين؛ أعد المحاولة",
    preferenceSessionEndedSaveFailed: "انتهت الجولة، لكن إعداد الإيقاف لم يُحفظ",
    premiumEstimate: "القسط التقديري {premium} JOULE ({rate}%)",
    premiumShortfallHint: "حساب التأمين ينقصه {amount} JOULE",
    premiumEstimateUnavailable: "تعذر تقدير القسط بعد",
    premiumBoundEstimate: "القسط التقديري للاستراتيجية المرتبطة {premium} JOULE",
    insuranceConfirmTitle: "تأكيد القسط",
    insuranceConfirmBody: "معاينة القسط {premium} JOULE. المعاينة نهائية. أكّد للإرسال.",
    actions: {
      rise: "Long",
      fall: "Short",
      buy: "Buy",
      sell: "Sell"
    },
    holdings: {
      current: "Positions",
      history: "History",
      currentCount: "المراكز المفتوحة {n}",
      empty: "No positions",
      historyEmpty: "No history"
    },
    position: {
      openPrice: "Open Price",
      closePrice: "Close Price",
      profitLoss: "profit / loss",
      countdown: "Settlement in",
      calculating: "Calculating...",
      settled: "Settled",
      settling: "Settling",
      active: "Active",
      settledAt: "Settled at"
    },
    modal: {
      amountPlaceholder: "Enter amount"
    },
    pairSelector: {
      title: "Select Pair",
      searchPlaceholder: "Search coins"
    },
    errors: {
      dataNotReady: "جاري تحميل البيانات، يرجى الانتظار"
    },
    marketPause: {
      default: "Market temporarily unavailable. Please try again later.",
      lastPriceStreamWarming: "Latest price feed is warming up. Please try again shortly.",
      marketWarming: "Market is warming up. Please try again shortly.",
      recovering: "Market is recovering. Please try again shortly.",
      clockNotSynced: "Server clock not synced. Please try again shortly.",
      symbolUnavailable: "This trading pair is not available"
    },
    toasts: {
      connectSuccess: "Connected successfully",
      connectCancelled: "You have cancelled the connection",
      connectFailed: "Connection failed"
    },
    openPriceLabel: "سعر الفتح",
    secondsUnit: "s",
    amountLabel: "المبلغ",
  },
  exchange: {
    title: "Flash Swap",
    from: "From",
    to: "To",
    balance: "Balance",
    all: "All",
    placeholder: "Please enter",
    fee: "Fee",
    minAmount: "Minimum swap amount: {amount} {symbol}",
    button: "Swap",
    tradeButton: "تداول",
    paymentCurrency: "عملة الدفع",
    estimatedGasFee: "رسوم الغاز المقدرة",
    gasPaymentNote: "سيتم استخدام رصيد GetGas لدفع رسوم الغاز",
    slippage: "الانزلاق",
    auto: "تلقائي",
    approximately: "تقريبا",
    minReceived: "الحد الأدنى المستلم",
    exchangeRate: "سعر الصرف",
    finalAmount: "المبلغ النهائي",
    confirm: "تأكيد",
    swapSuccess: "نجح التبديل السريع!",
    swapping: "جاري التبديل...",
    confirmTitle: "Confirm Action",
    confirmContent: "Are you sure you want to proceed?",
    toasts: {
      fetchFailed: "Failed to fetch assets",
      enterValidAmount: "Please enter a valid amount",
      minAmount: "Minimum swap amount is {amount} {symbol}",
      swapSuccess: "Swap successful",
      requestFailed: "Request failed",
      insufficientBalance: "Insufficient balance, unable to swap",
      usdtRestricted: "USDT under review; exchange unavailable"
    },
    rateHint: "{usdt} USDT={joule}JOULE, no fee",
    configFee: "رسوم Joule → USDT {fee}",
    configLimits: "الرسوم {fee} · حد القيمة قبل الخصم {min}–{max} U",
    unlimited: "غير محدود",
    quoteFailed: "تعذر الحصول على عرض السعر، أعد المحاولة"
  },
  globalNode: {
    title: "Global Node"
  },
  eventInsurance: {
    title: "Event Contract Insurance",
    availableBalance: "Available Balance (USDT)",
    fundTransfer: "Fund Transfer",
    fundHistory: "Fund History",
    type: "Type: ",
    all: "All",
    transfer: "Transfer",
    fundTransferTitle: "Fund Transfer",
    currency: "Currency",
    from: "From",
    to: "To",
    availableAccount: "Available Account",
    contractInsuranceAccount: "Contract Insurance Account",
    pleaseEnter: "Please enter",
    confirmTransfer: "Confirm Transfer",
    insufficientBalance: "Insufficient balance",
    transferSuccess: "Transfer successful",
    transferFailed: "Transfer failed",
    transferring: "Transferring...",
    noRecords: "No records",
    selectAccount: "Select Account",
    cannotTransferToSameAccount: "Cannot transfer to the same account",
    cannotTransferContractAccount: "Contract account transfer not supported",
    contractAccount: "Contract Account (TAKER)",
    rulesTab: "نظرة عامة",
    agreementTab: "الاتفاقية الكاملة",
    insuranceRulesTitle: "Insurance Rules",
    preview: {
      eventGroup: "I. قواعد توقع عقد الحدث",
      eventOpen: {
        title: "1. Insurance on",
        points: [
          "With insurance on, premium is based on order size vs account balance: ≤10% of balance → 15% premium; above → 20%.",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      eventLimit: {
        title: "2. Order threshold",
        points: [
          "Max per order is 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. Compensation entitlement rules",
        ok: [
          "50% of compensation goes to personal airdrop quota; every 50 USD unlocks one computing node",
          "30% goes to community airdrop quota by VIP rules; every 50 USD unlocks one computing node"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      eventPool: {
        title: "4. Event insurance pool payout:",
        points: [
          "Daily 2% of event insurance pool assets in PANTA is airdropped by node weight to eligible users",
          "When daily pool airdrops reach 50 USD in PANTA, one computing node is reduced"
        ]
      },
      eventProfit: {
        title: "5. P&L rules",
        points: [
          "Correct: receive principal 100% + profit (80%)",
          "Wrong: lose all stake principal; prediction ends"
        ]
      },
      aiGroup: "II. قواعد توقع الذكاء الاصطناعي",
      aiFirst: {
        title: "1. First order requires manual input"
      },
      aiOpen: {
        title: "2. Insurance on",
        points: [
          "With insurance on, pay 5%–10% of the position amount as premium",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      aiLimit: {
        title: "3. Order limits",
        points: [
          "Amounts must follow the position table, and each direction must match the AI signal",
          "If not following the table, it becomes a normal event contract prediction",
          "Eight consecutive losses unlock the stated compensation entitlement",
          "A winning order resets the sequence to step 1"
        ]
      },
      table: {
        level: "Account level",
        order1: "Order 1",
        order2: "Order 2",
        order3: "Order 3",
        order4: "Order 4",
        order5: "Order 5",
        order6: "Order 6",
        order7: "Order 7",
        order8: "Order 8"
      },
      claimOk: "Eligible for compensation",
      claimFail: "Not eligible for compensation",
      claimFailWhen: "When not eligible:",
      claimPrereq: "Compensation prerequisites:",
      aiClaim: {
        title: "4. Compensation entitlement",
        prereq: [
          "Insurance enabled",
          "Direction matches AI signal",
          "Amount/order follows the table",
          "Full settlement conditions met"
        ],
        ok: [
          "Cash compensation = cumulative loss × 90%"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      aiProfit: {
        title: "5. Profit rules",
        points: [
          "Correct: receive principal 100% + profit 80%",
          "Wrong: lose all stake principal; prediction ends or compensation applies"
        ]
      }
    },
    rulesContent: "PANTA Market اتفاقية تأمين خطة حماية تداول عقود الأحداث\n\n【إشعار مهم】قبل استخدام هذه الخدمة، يُرجى قراءة محتوى الاتفاقية بالكامل بعناية وفهمه جيدًا. سيعتبر النظام أن تشغيل المستخدم 「مفتاح التأمين」 يعني أنك قرأت وفهمت وقبلت الاتفاقية والمرفقات بالكامل، وتؤكد أن الاتفاقية ملزمة قانونيًا، وتوافق على الالتزام بها بدقة؛ وإذا لم توافق ولم تقبل، فتوقف فورًا عن استخدام خطة الحماية هذه.\n\nالمادة 1: أحكام عامة ونطاق التطبيق\n\n1.1 تُستخدم هذه الاتفاقية لشرح طريقة المشاركة، وتكوين الأوامر، والرسوم، وتحديد النتائج، وتسوية الأموال، والتعويضات المشروطة، وحقوق العُقدة المرتبطة، ووظائف التنبؤ بالأحداث لنوعي الوظيفتين 「تنبؤ عقد الحدث」 و「تنبؤ عقد الحدث AI」 داخل PANTA Market. ينطبق على كل منتج بنوده الخاصة، ولا يجوز نقل معدلات أو شروط التعويض أو قواعد العُقدة من منتج إلى آخر مباشرة.\n1.2 تنبؤ عقد الحدث هو وظيفة يحكم فيها المستخدم على حدث مُدرج مسبقًا ونتائجه الاختيارية، ويستخدم JOULE للإرسال وإنشاء الأمر. يمكن للخسارة المؤهلة النهائية وفق القواعد المعتمدة إنشاء حد العُقدة شخصي أو فريق مجتمعي؛ وهذا الحد ليس تعويضًا نقديًا فوريًا. تنبؤ عقد الحدث AI هو وظيفة يشارك فيها المستخدم بالرجوع إلى إشارة اتجاه تنبؤ AI صالحة يقدمها النظام، ويؤكد المشاركة أمرًا بأمر وفق المبلغ الثابت وترتيب الخطة المختارة لإنشاء الأوامر. عند تسوية 8 أوامر في تسلسل مؤهل واحد بالكامل وكانت جميعها خسارة، مع استيفاء شروط أخرى محددة في آن واحد، يُحسب تعويض JOULE بنسبة 90% من إجمالي رأس المال المؤهل. إشارة AI ليست ضمانًا للنتيجة، والتعويض المشروط لا يغطي كل النفقات.\n1.3 تشكل هذه الاتفاقية، والمعلمات المُصدَرة للمنتج المعني، وقواعد الحدث المحددة، وصفحة تأكيد المستخدم معًا القواعد الكاملة. يمكن للصفحة عرض المعلمات المعتمدة فقط، ولا يجوز استبدال غياب الشروط الجوهرية بعبارة 「الصفحة هي المرجع」. عند التعارض بين المستندات، يجب إيقاف المعاملات الجديدة المتأثرة وشرح الأمر والتحقق منه وتصحيحه، ولا يجوز لاحقًا اختيار تفسير أقل فائدة للمستخدم بشكل أحادي لمعالجة الأوامر القائمة.\n1.4 يتعلق هذا المشروع بأصول حقيقية، وتنبؤ الأحداث، وتعويضات مشروطة، وتسمية التأمين، ومكافآت الفريق، والتبادل، ومجمعات الأموال، وليس منتجًا يمكن تجاوز مراجعة المخاطر والامتثال. يجب إجراء تحقق مهني لطبيعة كل وظيفة قانونيًا، والتراخيص، ومناطق التقديم، وأهلية المستخدم، ومكافحة غسل الأموال، وحماية المستهلك، ومتطلبات معالجة البيانات وفق نطاق الخدمة الفعلي. لا تُغني بنود إخلاء المسؤولية عن التراخيص اللازمة وترتيبات الأموال وإجراءات الرقابة؛ ولا يفترض هذا النص تطبيق قانون دولة معينة، ولا يُقر بأن المنتج حاصل على ترخيص تشغيل قانوني.\n\nالمادة 2: المصطلحات وحالة الأموال\n\n2.1 JOULE هو وحدة القياس لرأس مال التنبؤ وقسط التأمين وتعويض AI في تصميم هذا المنتج؛ PANTA هو وحدة الأصول المستخدمة في توزيع حقوق العُقدة وغيرها من الأعمال؛ المعادل USDT هو أساس القياس لبعض الحدود وحسابات القيمة. لا يجوز خلط الثلاثة، وعرض الأرقام الداخلية لا يعني إمكانية التحويل الفوري إلى عملة قانونية بسعر صرف ثابت، ولا يعني اكتمال نقل الأصول على السلسلة؛ وهذا التوضيح لا يلغي حقوق الأصول أو التزامات الدفع المتكونة قانونًا وتعاقديًا.\n2.2 رأس مال الأمر هو مبلغ JOULE الذي يؤكده المستخدم فعليًا ويقبله النظام في ذلك الأمر، دون شمول قسط التأمين. قسط التأمين هو التكلفة المحسوبة وفق القواعد المطبقة على ذلك الأمر. يكون الإجمالي المجمّد عادة مجموع رأس المال والقسط؛ وإذا وُجدت تكاليف أخرى فيجب الإفصاح عنها مسبقًا بشكل منفصل، ولا يجوز إضافة رسوم غير مؤكدة عند التسوية.\n2.3 الرصيد المتاح هو الرصيد القابل للاستخدام في عمليات جديدة وفق قواعد الحساب الحالية. الرصيد المجمّد هو المخصص للأوامر المقبولة أو الأعمال المعتمدة، ولا يمكن استخدامه مؤقتًا لعمليات أخرى. الأرباح المتوقعة، والتعويضات قيد المراجعة، وحدود العقد، والتوزيعات غير المُسجّلة لا تُحسب ضمن الرصيد المتاح. يجب أن يُبيّن عرض الرصيد اسم الأصل، ولا يُسمح بجمع كميات أصول مختلفة مباشرة.\n2.4 تسلسل AI هو سجل الأعمال المتسلسل من الأمر الأول وفق القواعد لنفس الخطة المؤكدة. يحتفظ الخادم بالخطوة الحالية ونتيجة الأمر وأدلة الأهلية. انقطاع الشبكة العادي أو الخروج من التطبيق لا يُعد إنهاء تسلسل الأعمال؛ وإعادة التعيين هي إنهاء التسلسل القديم بعد استيفاء شروط هذه الاتفاقية.\n2.5 حد العُقدة قوة الحوسبة هو وحدة محاسبية معادلة USDT تُتراكم وفق القواعد بناءً على الخسارة المؤهلة النهائية لإنشاء العُقدة. العُقدة هي سجل أهلية المشاركة في توزيع الحقوق لاحقًا، وليس نقدًا فوريًا أو PANTA مُودَعًا، ولا يصبح NFT على السلسلة قابلًا للتداول أو الرهن أو النقل الحر لمجرد الاسم.\n2.6 لقطة القواعد هي إصدار القواعد والمعلمات والمبالغ وأساس السعر والبنود والأدلة ذات الصلة المحفوظة عند تأكيد الأمر أو التسلسل. لا يمكن للإصدار الجديد أن يستبدل اللقطات القديمة. تُستخدم سجلات الخادم للتحقق من حالة العمليات، لكن يمكن للمستخدم تقديم أدلة أخرى لطلب مراجعة؛ ولا يجوز استبعاد الاعتراض المعقول لمجرد أن السجلات محفوظة لدى المنصة.\n\nالمادة 3: أهلية الاستخدام وتأكيد الاتفاقية\n\n3.1 يمكن للمنصة تقديم الوظائف المعنية للمستخدمين فقط ضمن مناطق الخدمة المعتمدة ونطاقات العمر والملاءمة. يجب أن تحدد النسخة الرسمية متطلبات التحقق من الهوية ونطاق توفر المنتج وأسباب القيود. لا يجوز اعتبار المستخدم مؤهلًا لجميع المنتجات لمجرد اتصال المحفظة أو ظهور الواجهة أو وجود رصيد في الحساب.\n3.2 يجب على المستخدم استخدام حسابات وأصول يملك السيطرة عليها؛ ويُحظر انتحال الهوية، أو استخدام حسابات الغير دون إذن، أو تزوير مستندات الأهلية، أو التلاعب بالإشارات أو أدلة النتائج. عند حاجة المنصة لتحقق إضافي، يجب توضيح المستندات المطلوبة والغرض التجاري؛ ويجب توضيح قيود المشاركة الجديدة ومعالجة تنفيذ الأوامر القائمة بشكل منفصل.\n3.3 قبل تقديم الأمر يجب أن يتمكن المستخدم من الاطلاع على رأس المال وقسط التأمين والتكاليف الإضافية المحتملة وخيارات التنبؤ وأسوأ خسارة وشروط التسوية ومصدر التحديد ومسار النزاع. يجب أن توفر المنصة خطوات تأكيد واضحة، ولا تستبدل تأكيد المستخدم الحقيقي بالموافقة الافتراضية أو الرسوم المخفية أو تبديل المبلغ تلقائيًا أو حث التكرار.\n3.4 إشارات AI والنتائج التاريخية وأمثلة الأرباح وحجم مجمع العُقدة وسجلات حقوق الآخرين لا تشكل وعدًا بنتائج مستقبلية. قد يخسر المستخدم رأس مال الأوامر المقبولة وقسط التأمين ذي الصلة، وقد تتأثر حقوق العُقدة برصيد المجمع والوزن الفعّال والسعر وحالة المعالجة. لا ينبغي للمستخدم اعتبار مثال معين دخلًا ثابتًا أو مدة استرداد محددة له.\n\nالمادة 4: قواعد تنبؤ عقد الحدث\n\n4.1 قبل بدء تسلسل AI، يجب على المستخدم الاطلاع على الخطط المتاحة ورأس مال مركز التنفيذ وقسط التأمين المتوقع وإجمالي احتياج الأموال وصلاحية الإشارة وقاعدة التسوية 60 ثانية وشرط التعويض 90%. يمكن بدء تسلسل جديد من الأمر الأول فقط، ولا يجوز تبديل الخطة أثناء التسلسل؛ ولا يمكن للمستخدم تجميع تخطي خطوات أو تغيير المبلغ أو أوامر معلقة متوازية لتكوين تسلسل مؤهل جديد. بعد اختيار نتيجة الحدث وإدخال رأس مال JOULE، تحسب المنصة قسط التأمين وفق أساس المركز المعتمد. التصميم الحالي: إذا لم يتجاوز رأس المال 10% من أساس المركز، يكون القسط 15% من رأس المال؛ وإذا تجاوز 10% يكون 20%. عند حد 10% بالضبط يُطبق 15%.\n4.2 يجب أن تعرض إشارة AI الأصل والاتجاه والوقت ومدة الصلاحية ورقم الإشارة القابل للتعرف. عند تقديم الأمر يجب على المستخدم تأكيد اتجاه يطابق الإشارة الصالحة آنذاك. إذا تحدّثت الإشارة أثناء الانتظار أو إعادة الاتصال، فيجب إعادة التحقق؛ ولا يمكن الاستمرار في استخدام إشارة منتهية من ذاكرة العميل. اعتماد إشارة AI لا يعني أن المنصة أو الخوارزمية تعرف النتيجة المستقبلية. الدقة التاريخية وسجلات العرض وشرح التنبؤ لا يمكن أن تكون ضمانًا لنتيجة هذا الأمر. لا يجوز للمنصة استخدام عبارات مثل 「فوز مضمون」 أو 「ربح ثابت」 أو 「لا خسارة عند الخطأ」 بدل رأس المال وقسط التأمين وشروط التعويض الفعلية.\n4.3 يجب أن يسرد كل حدث بشكل مستقل الاسم ووصف الوقائع والنتائج الاختيارية وأوقات الفتح والإغلاق والمنطقة الزمنية وحدود المشاركة ومعايير تحديد النتيجة ومصادر الأدلة الرئيسية والاحتياطية وحساب الربح وأسوأ خسارة وقواعد الإلغاء أو التأجيل وإجراءات الاعتراض. بالنسبة للأحداث الغامضة أو التي تفتقد معايير التحديد أو التي لم تُعتمد معلماتها الاقتصادية الجوهرية، لا يجوز فتح أوامر حقيقية. عند قبول الأمر يجب على المنصة التحقق من أن الحدث ما زال مفتوحًا، وأن وقت الخادم قبل وقت الإغلاق، وأن الخيارات والإصدار صالحة، وأن أهلية المستخدم وحدوده مستوفاة، وأن الرصيد كافٍ. لا يُحكم الإغلاق بوقت جهاز المستخدم ولا باستمرار ظهور العد التنازلي عند النقر.\n4.4 بعد تجميد رأس المال والقسط بنجاح وقبول الأمر، تُعيد المنصة وقت القبول ونقطة التسوية المتفق عليها. تُحسب هذه النقطة بوقت قبول الخادم زائد 60 ثانية، وليس من فتح الصفحة أو استلام الإشارة أو النقر. لا يُقصّر أو يُطيل تأخير الشبكة معيار التحديد المُحدَّد. 60 ثانية تعني نقطة تحديد النتيجة المتفق عليها، ولا تعد بإتمام إيداع الأموال في اللحظة التي يصل فيها العد التنازلي للعميل إلى صفر. بعد الوصول إلى النقطة يجب الحصول على دليل النتيجة من المصدر المتفق عليه؛ وعند غياب الدليل أو شذوذ المصدر أو تعارض النتائج، تُحفظ حالة انتظار التسوية مع توضيح، ولا يُسجَّل خسارة تلقائيًا.\n4.5 فقط عند وجود تسلسل ساري حالي، وعرض القواعد بوضوح، وعدم وجود أوامر معلقة، وإذا أرسل المستخدم فعليًا اتجاهًا لا يطابق الإشارة الصالحة أو مبلغًا لا يطابق الخطوة الثابتة الحالية، يُطبَّق تصميم الرفض وإعادة التعيين الذي ينهي التسلسل القديم. يجب عرض السبب المحدد والتسلسل المتأثر والإجراء التالي القابل للتنفيذ مع حفظ السجل. بعد إعادة التعيين يمكن في المرة التالية إنشاء تسلسل جديد من الأمر الأول؛ ولا يجوز ربط أوامر الخسارة في التسلسل القديم بأوامر التسلسل الجديد لحساب 8 خسائر متتالية. تُحفظ الأرباح والخسائر المكتملة في التسلسل القديم ولا تُمنح تلقائيًا تعويض 90%؛ دون أن يمنع ذلك طلب مراجعة بسبب خطأ المنصة أو إعادة تعيين خاطئة أو نزاع آخر.\n4.6 طلب المخالفة المرفوض لا يُنفَّذ ولا يُنشئ خسارة رأس مال أو قسطًا أو عُقدة خسارة جديدًا. صياغة تحويل خسارة المخالفة إلى عُقدة في المواد الأصلية لم تُشكّل بعد قاعدة قابلة للتنفيذ؛ ولا يجوز بناءً عليها اختلاق خسارة أو تعويض للأوامر المرفوضة.\n4.7 إيقاف المستخدم لبدء الخطوات اللاحقة لا يعني أن 8 خسائر متتالية قد تشكّلت؛ ولا يمكن للتسلسل غير المكتمل طلب تعويض 90% بنسبة عدد الأوامر الخاسرة. إنهاء التسلسل طوعًا والبقاء طويلًا ومدد الاستئناف تحتاج تأكيد قواعد رسمية؛ ولا يجوز إضافة مدة انتهاء غير مُفصح عنها. لا يُفسَّر الخروج العادي أو انقطاع الشبكة على أنه تنازل طوعي. يجب أن يستوفي التسلسل الواحد هذه الشروط الأربعة في آن واحد لحساب تعويض JOULE 90% وفق التصميم الحالي: في كل أمر يكون آلية التأمين مفعّلة فعليًا ويُجمَّد رأس المال وقسط ذلك الأمر بنجاح؛ واتجاه كل أمر يطابق إشارة AI الصالحة عند القبول؛ ورأس مال كل أمر وترتيب الخطوات يطابق الخطة المؤكدة؛ و8 أوامر تُسوَّى بالكامل وجميع النتائج خسائر مؤهلة. مبلغ التعويض هو مجموع رأس مال مشاركة 8 أوامر مؤهلة × 90%، يُقاس ويُدفع بـ JOULE؛ ولا يدخل القسط في أساس 90% ذلك. لا يمكن التعبير عن التعويض مباشرة بأنه إرجاع 90% من كل النفقات، ولا يُحوَّل تلقائيًا إلى USDT أو نقد أو PANTA. تبادل الأصول الأخرى يحتاج قواعد وترخيصًا مستقلين.\n4.8 تكوين أهلية التعويض ونجاح الدفع مرحلتان. عند توفر الأهلية مع نقص الأموال أو شذوذ محاسبي أو قيود مطبقة، تُحفظ التزامات وانتظار الدفع والتفاصيل، ويُعرض قيد المعالجة أو سبب التعليق بوضوح، ثم تُعالج وفق القانون والعقد؛ ولا يجوز إعادة صياغة صعوبة الدفع على أنها عدم أهلية المستخدم.\n4.9 يُنفَّذ التعويض مرة واحدة وفق السجل الوحيد لذلك التسلسل. إذا نجح الدفع وفُقدت الاستجابة، يجب أن تُعيد الاستعلامات والمحاولات اللاحقة النتيجة الأصلية دون دفع مكرر. يجب أن يحافظ فشل الدفع على حالة عدم اكتمال حقيقية؛ ولا يُطلب من المستخدم إنشاء تسلسل جديد أو إعادة الطلب ل「تفعيل」 التعويض الأصلي. إذا سمح آلية التأكيد المسبق في نفس التسلسل بمعدلات مختلفة لكل أمر، فيجب الاحتفاظ بلقطة لكل أمر وتجميع التكلفة الفعلية؛ ولا يمكن إعادة حساب كل الأوامر التاريخية بمعدل حالي واحد. تغيير آلية المعدلات المؤثرة على تسلسل مؤكد يجب أن يحدد نطاق التطبيق أولًا؛ ولا يجوز زيادة التكلفة بأثر رجعي عبر صفحة جديدة.\n4.10 يجب تحديد أصغر وحدة للأصل والدقة وطريقة التقريب لكل أمر ومعالجة الباقي قبل الإطلاق والحفاظ على اتساقها. تقريب الصفحة لسهولة القراءة لا يغيّر تفاصيل الحسابات؛ ودقة أمثلة الحساب ليست دقة الدفع المعتمدة. لا يجوز إخفاء الرسوم والفرق السعري والباقي بعرض مجمّع.\n\nالمادة 5: خدمات النظام\n\n5.1 انقطاع الشبكة أو انتهاء مهلة الطلب: يستعلم المستخدم عن الأمر الأصلي أولًا، وتُعيد المنصة الحالة الفعلية المقبولة أو المرفوضة صراحة أو قيد التأكيد. عند مجهولية النتيجة الأصلية لا يجوز حث الدفع المكرر؛ وبعد التأكيد اللاحق بعدم القبول فقط يمكن إعادة تأكيد طلب جديد وفق القواعد السارية.\n5.2 انتهاء الإشارة أو العرض: رفض الطلب القديم وعرض السبب وإعادة جلب المحتوى. لا يجوز الاستبدال الصامت باتجاه أو مبلغ أو تكلفة جديدة، ولا اعتبار الانتهاء تلقائيًا إعادة تعيين مخالفة AI. إذا كان الطلب القديم مقبولًا بالفعل، يُنفَّذ وفق لقطة ذلك الطلب.\n5.3 شذوذ النتيجة أو السعر: إيقاف التحديد أو التقييم أو التوزيع المتأثر؛ وتوفير الحالة ونطاق التأثر وقناة الاستعلام. غياب النتيجة لا يُسجَّل خسارة فاشلة؛ والتقييم الشاذ لا يُستخدم لتوسيع أساس الخسارة. تغيير المصدر الاحتياطي يجب أن يلتزم بترتيب المصادر وقواعد الشذوذ المُعلَن عنها مسبقًا.\n5.4 فرق الحسابات أو حالة المعاملة الخارجية مجهولة: التحقق من السجل الأصلي وإيصال خارجي أولًا؛ وعدم إعادة إرسال إجراءات لا رجعة فيها. بعد تأكيد الفشل، فك التجميد أو إعادة المحاولة وفق القواعد؛ والمجهول لا يعني استردادًا مكتملًا. إجراءات أموال المستخدم المكتملة وخطوات شراء العملة أو الإيداع في المجمع غير المكتملة يجب عرضها بشكل منفصل.\n5.5 نقص الأموال: إيقاف الأعمال الجديدة التي قد توسّع العجز، والاحتفاظ بالالتزامات المتكونة، وإبلاغ حالة الانتظار، والمعالجة وفق الخطة المعتمدة. لا يجوز تزوير الإيداع أو جعل الرصيد المتاح سالبًا أو سد الفرق برسوم إضافية غير مُبلَّغ عنها.\n5.6 قيود المخاطر: يمكن للمنصة إجراء تحقق أو قيود لازمة وفق قواعد معتمدة رسميًا ومُفصح عنها بشكل مناسب، لكن يجب التمييز بين قيد الأوامر الجديدة وتأخير الدفع وإلغاء الأهلية. لا يجوز للقيود إعادة كتابة نتائج تاريخية أو شروط اقتصادية مستوفاة تلقائيًا؛ ويجب أن يكون للاستثناءات وقائع وأساس، مع توفير مسار مراجعة متاح.\n5.7 عند الصيانة أو إيقاف الخدمة أو إغلاق منتج، يجب أن تظل هناك ترتيبات لمعالجة الأوامر التاريخية والتعويضات والنزاعات والسجلات القابلة للمراجعة. عدم قدرة المستخدم على إضافة معاملات جديدة لا يعني زوال الرصيد القائم أو التعويضات المستحقة أو حق الاعتراض. إيقاف مفتاح الأعمال الجديدة لا يجب أن يُغلق معه كل استعلامات التاريخ وإجراءات التنفيذ.\n\nالمادة 6: بنود إخلاء المسؤولية\n\nعن الخسائر الناتجة عن الحالات التالية، لا تتحمل الخدمة مسؤولية التعويض:\n6.1 عدم التزام المستخدم بالاستراتيجية: أي سلوك يخرج عن لوائح إدارة المراكز القياسية لهذه المنصة\n6.2 ظروف السوق القصوى: خسائر بسبب شلل البورصة أو نضوب السيولة أو التلاعب بالسوق\n6.3 مخاطر النظام والتشغيل: خسائر بسبب عطل جهاز المستخدم أو خطأ في التشغيل أو سرقة الحساب\n6.4 مخاطر السياسة والامتثال: انقطاع أو حظر التداول بسبب تغيير القوانين أو اللوائح أو أوامر الرقابة\n6.5 مخاطر الرمز الداخلي: هبوط حاد أو انهيار القيمة السوقية لـ JOULE يؤثر على وظيفته كضمان وعملة تسوية\n6.6 الاحتيال والسلوك الخبيث: مشاركة المستخدم في احتيال أو غسل أموال أو تلاعب بالسوق أو أنشطة غير قانونية أخرى\n6.7 القوة القاهرة: عطل نظام هذه المنصة بسبب القوة القاهرة\n\nالمادة 7: الإفصاح عن المخاطر\n\nيؤكد المستخدم أنه فهم وقبل المخاطر التالية بشكل كافٍ:\n7.1 عدم ضمان رأس المال أو الربح: هذه الخطة تعوّض جزءًا من الخسائر فقط ولا تضمن مطلقًا سلامة رأس المال أو الربح\n7.2 مخاطر الاعتماد على الاستراتيجية: فعالية الحماية تعتمد كليًا على الالتزام الصارم بالاستراتيجية\n7.3 مخاطر السيولة والحجز: أموال التعويض في حساب إدارة الثروات قد تنطوي على مخاطر استثمار وفترة حجز تؤثر على السيولة\n7.4 مخاطر الأطراف الثالثة: مخاطر التشغيل والأمن وتقلب القيمة للبورصات المعتمدة\n7.5 مخاطر عدم يقين التنظيم: تواجه هذه المنصة عدم يقين تنظيمي عالمي ومخاطر الإيقاف\n7.6 مخاطر الأمن التقني: تشمل مخاطر فقدان الأصول بسبب ثغرات smart contract أو هجمات قرصنة وغيرها\n\nالمادة 8: تعديل الاتفاقية وإنهاؤها والنزاعات\n\n8.1 تعديل الاتفاقية: تحتفظ هذه المنصة بحق مراجعة هذه الاتفاقية وفق القوانين أو احتياجات التشغيل؛ وستُبلَّغ التغييرات الجوهرية عبر إعلان المنصة\n8.2 إنهاء الاتفاقية: يمكن للمستخدم إيقاف مفتاح الحماية في أي وقت لإنهاء الخدمة؛ وإذا خالف الاتفاقية يمكن للمنصة الإنهاء من جانب واحد؛ وقد تُنهى هذه الخطة لأسباب قانونية أو سياسية\n8.3 حل النزاعات: تُحل النزاعات الناشئة عن هذه الاتفاقية بالتفاوض الودي؛ وإذا فشل التفاوض تُرفع إلى هيئة التحكيم أو المحكمة المعيّنة\n\n【التأكيد النهائي】أنت تفهم وتوافق على أن 「تفعيل مفتاح التأمين」 هو الطريقة الوحيدة والنهائية لتأكيد التزامك بكل محتوى هذه الاتفاقية؛ يُرجى اتخاذ القرار بناءً على حكم مستقل.",
    lockedBalance: "Non-transferable",
    equityTitle: "Event insurance equity",
    personalEquity: "Personal equity",
    teamEquity: "Team equity",
    equityNodes: "Active nodes",
    remainingEquity: "Remaining equity",
    peersPaid: "Peer paid",
    peersPending: "Peer pending",
    creditsCount: "Credit rows",
    nodeBatches: "Node batches",
    peerRows: "Pending peer rows",
    recentPayouts: "Recent payouts",
    premiumRules: "Position threshold {threshold}% · low premium {low}% · high premium {high}% (preview wins per order)",
    insuranceDeduction: "Insurance premium deduction (Event)",
    insurancePayout: "Insurance premium payout (Event)"
  },
  walletBind: {
    connectWallet: "Connect",
    inputPlaceholder: "Enter address",
    bind: "Bind",
    binding: "Binding",
    tip: "Tip: If wallet connection fails, you can try manually entering the wallet address to bind"
  },
  loginModal: {
    title: "تسجيل الدخول إلى PANTA MARKET",
    connectWallet: "ربط",
    connecting: "جاري الاتصال...",
    alreadyConnected: "متصل",
    tip: "نصيحة: إذا فشل الاتصال بالمحفظة، يمكنك محاولة إدخال عنوان المحفظة يدويًا للربط",
    inputLabel: "أدخل عنوان المحفظة",
    inputPlaceholder: "0x234d456f6798...",
    bind: "ربط",
    binding: "جاري الربط",
    bindSuccess: "تم الربط بنجاح",
    bindSuccessHint: "تم الربط بنجاح، يرجى تسجيل الدخول مرة أخرى",
    bindFailed: "فشل الربط",
    noAuthCode: "رمز التفويض مفقود",
    invalidAddress: "تنسيق عنوان المحفظة غير صالح",
    confirmTitle: "تأكيد الربط",
    confirmWarning: "يرجى التأكد بعناية من أن العنوان التالي هو عنوان محفظتك. لا يمكن تغييره بعد الربط",
    addressLabel: "عنوان المحفظة",
    cancel: "إلغاء",
    confirm: "تأكيد الربط",
    loginSuccess: "تم تسجيل الدخول بنجاح",
    openWalletApp: "فتح {wallet}",
    openWalletConnect: "افتح {wallet} للاتصال",
    openWalletSign: "افتح {wallet} للتوقيع",
    returnToBrowser: "عد إلى هنا بعد الانتهاء",
    loginStepLabel: "الخطوة {step}/2",
    stepConnectTitle: "ربط المحفظة",
    stepConnectHint: "وافق على الاتصال في محفظتك ثم عد إلى هنا",
    stepConnectHintWithOpen: "اضغط بالأسفل لفتح محفظتك والموافقة على الاتصال ثم عد إلى هنا",
    stepSignTitle: "تسجيل الدخول",
    stepSignHint: "وقّع رسالة تسجيل الدخول في محفظتك (لن تُنقل أي أصول) ثم عد إلى هنا",
    stepSignHintWithOpen: "خطوة أخيرة: اضغط بالأسفل لفتح محفظتك وتوقيع رسالة تسجيل الدخول",
    waitingWalletHintShort: "إن لم تُفتح تلقائيًا، اضغط بالأسفل لفتح المحفظة",
    retryLogin: "إعادة محاولة تسجيل الدخول",
    networkRequired: "تبديل الشبكة",
    networkRequiredHint: "بدّل إلى {chain} ثم عد إلى هنا وأعد المحاولة",
    switchingNetwork: "تأكيد تبديل الشبكة",
    switchingNetworkHint: "وافق على التبديل إلى {chain} في محفظتك",
    signatureRequired: "وقّع لتسجيل الدخول",
    signatureHint: "وقّع في محفظتك — هذا لا ينقل أي أموال",
    verifyingLogin: "جارٍ التحقق",
    verifyingHint: "يرجى الانتظار",
    connectFailed: "الاتصال غير مكتمل، يرجى المحاولة مجددًا",

    waitingWalletReturn: "Finish authorizing in the wallet app, then return here",
    waitingWalletHint: "Authorize in your wallet app; you will return here automatically"
  },
  walletProfile: {
    title: "Profile",
    address: "Address",
    accountName: "Account Name",
    inviteCode: "Invite Code",
    deactivateAccount: "Deactivate Account",
    logout: "Logout",
    switchAccount: "Switch Account",
    confirmLogout: "Are you sure you want to logout?",
    loggingOut: "Logging out...",
    confirmSwitch: "Are you sure you want to switch account? Current account will be logged out",
    developing: "Under Development",
    addressCopied: "Address Copied",
    inviteCodeCopied: "Invite Code Copied"
  },
  aiPrediction: {
    stakeAutofill: "مساعدة الذكاء الاصطناعي",
    stakeAutofillWarning: "للمساعدة فقط. قد يكون المبلغ المقترح خاطئًا؛ تحقق قبل الطلب. يتوقف التعبئة التلقائية عند تجاوز التأخير 800 مللي ثانية أو فشل/انتهاء فحص الاتصال، ويستأنف بعد الاستعادة. لا يؤثر على الطلبات اليدوية.",
    stakeAutofillUnavailable: "الاتصال غير مستقر أو التأخير فوق 800 مللي ثانية. لا يمكن التفعيل بعد.",
    stakeAutofillPaused: "التعبئة التلقائية متوقفة: الاتصال غير مستقر. أدخل المبلغ يدويًا.",
    insuranceSyncing: "جارٍ مزامنة مرحلة التأمين…",
    predictionBuffer: 'جارٍ تحضير التوقع التالي',
    scheduleResultPending: 'نتيجة الجولة غير متاحة، جارٍ إعادة المحاولة',
    title: "AI Prediction",
    bookingTitle: "حجز جلسات الذكاء الاصطناعي",
    bookingExpand: "توسيع",
    bookingCollapse: "طي",
    bookingNextSystem: "الجلسة التالية · SGT",
    bookingNextMine: "حجزي التالي",
    bookingNone: "لا يوجد",
    bookingStartingSoon: "جلستك المحجوزة ستبدأ قريبًا",
    bookingToday: "اليوم",
    bookingTomorrow: "غدًا",
    bookingTimezone: "SGT",
    bookingQuota: "الجلسات المتبقية: {remaining}/{dailyLimit}",
    bookingSeats: "{occupied}/{capacity} مقعد",
    bookingEmpty: "لا توجد جلسات متاحة",
    bookingWaiting: "ستدخل تلقائيًا بعد انتهاء العملية الحالية",
    bookingEnded: "انتهت",
    bookingJoin: "الانضمام للجلسة",
    bookingReserve: "حجز",
    bookingJoined: "تم الدخول",
    bookingReserved: "محجوز",
    bookingFull: "مكتمل",
    bookingConfirm: "تأكيد الحجز",
    bookingWarning: "الحجز الناجح يخصم جلسة واحدة لليوم حتى إن لم تحضر.",
    bookingQuotaExhausted: "استخدمت كل جلسات اليوم المتاحة",
    bookingUnavailable: "الحجز غير متاح حاليًا",
    bookingFailed: "فشل الحجز. حدّث الصفحة وحاول مجددًا.",
    aiPool: "مجمع AI",
    countdown: "Countdown",
    expectedProfit: "Expected Profit",
    active: "Active",
    aiAnalysis: "AI Smart Rise/Fall Probability Analysis",
    updateTime: "Update Time",
    probabilityUp: "Bullish Probability",
    probabilityDown: "Bearish Probability",
    startPrediction: "Start Prediction",
    predicting: "Predicting...",
    stayOnPageHint: "لا تغادر هذه الصفحة، وإلا قد تضيع نتيجة التوقع.",
    userInfo: "User Info",
    predictCount: "Prediction Count",
    freeCount: "Free Predictions",
    openTime: "Open at: {time1}",
    up: "Up",
    down: "Down",
    notConnected: "Not Connected",
    count: "Count",
    learnMore: "Learn More",
    calculating: "Calculating...",
    settled: "Settled",
    loginFirst: "Please login first",
    sessionSyncing: "جارٍ المزامنة",
    actions: {
      rise: "Long",
      fall: "Short"
    },
    holdings: {
      current: "Positions",
      history: "History",
      empty: "No positions",
      historyEmpty: "No history",
      aiHistory: "AI History",
      aiHistoryEmpty: "No AI history"
    },
    buyModal: {
      title: "شراء الامتياز",
      description: "شراء 30 توقع بالذكاء الاصطناعي",
      upgradeAmount: "مبلغ الترقية",
      balance: "الرصيد المتاح",
      cancel: "Cancel",
      confirm: "تأكيد",
      purchasing: "جاري الشراء...",
      purchaseSuccess: "تم الشراء بنجاح",
      purchaseFailed: "فشل الشراء",
      dailyLimit: "You can purchase once per day."
    },
    noPredictionAlert: {
      title: "فشل التوقع بالذكاء الاصطناعي",
      description: "عدد توقعاتك بالذكاء الاصطناعي هو 0. لا يمكنك استخدام التوقع بالذكاء الاصطناعي في الوقت الحالي. يرجى الشراء للمتابعة.",
      cancel: "إلغاء",
      confirm: "شراء توقع بالذكاء الاصطناعي"
    },
    toasts: {
      predictionFailed: "Prediction failed",
      predictionSuccess: "Prediction completed",
      premiumShortfallReminder: "Full-round premium shortfall ~{amount} JOULE (reminder only; this order can still submit)",
      deferredWaitSettlement: "Signal ready; wait for the open position to settle before placing",
      insuranceTierUnavailable: "Insurance tier unavailable; try again later",
      insuranceCancelFailed: "Cannot close; unsettled orders may exist",
      resumeFailed: "Failed to resume prediction; try again later",
      requiredStakeInvalid: "Invalid prediction stake; start AI prediction again"
    },
    analyzing: "Analyzing...",
    insurance: "التأمين",
    insuranceOn: "مفعّل",
    insuranceOff: "غير مفعّل",
    aiLabel: "AI",
    lookLong: "صعود",
    lookShort: "هبوط",
    waitingResult: "Waiting",
    startAIPrediction: "Start AI Prediction",
    scheduleConfirm: "متابعة هذه الجولة",
    scheduleBinding: "جارٍ ربط الإشارة...",
    predictionResult: "AI Prediction Result",
    nextRound: "Next Round",
    rise: "Long",
    fall: "Short",
    openPrice: "سعر الفتح",
    settledAt: "وقت التسوية",
    ordinaryInsuranceTitle: "هذا الأمر تأمين عادي",
    ordinaryInsuranceBody: "هذا الأمر تأمين عادي وليس تعويض جولة الذكاء الاصطناعي. بعد التأكيد يُرسل حسب قسط المعاينة.",
    sessionConflict: "هناك جولة تأمين ذكاء اصطناعي نشطة. استعدها أو أنهِها قبل التأمين العادي.",
    conversionTitle: "التحويل إلى تأمين عادي؟",
    conversionDesc: "سيتحول هذا الطلب إلى تأمين عادي وينهي جولة تأمين AI الحالية. خسائر AI المتتالية السابقة لن تُعوَّض. قسط التأمين العادي {premium} JOULE.",
    conversionConfirm: "تأكيد التحويل والطلب",
    stakeFromStrategy: "الحجم تحدده الاستراتيجية",
    stakeTier: "المستوى {tier}",
    stakeStep: "الخطوة {step}",
    selfQuotaRemaining: "مرات التنبؤ الذاتي المتبقية: {remaining}/{limit}",
    followRoundProgress: "متابعة الذكاء الاصطناعي · الجولة {current}/{total}",
    followRoundsCompleted: "اكتملت متابعة الذكاء الاصطناعي · {current}/{total}",
    selfQuotaLoadingShort: "جارٍ تحميل المرات",
    selfQuotaLoginHint: "سجّل الدخول لعرض المرات",
    selfQuotaLoading: "جارٍ تحميل المرات، حاول لاحقاً",
    selfQuotaExhausted: "استُنفدت مرات التنبؤ الذاتي المجانية اليوم؛ التنبؤ المدفوع غير متاح بعد"
  },
  positionModal: {
    title: "توقع السعر",
    insurance: "التأمين",
    long: "شراء",
    short: "بيع",
    balance: "الرصيد",
    loading: "جاري التحميل...",
    confirm: "تأكيد",
    processing: "جاري معالجة الطلب...",
    success: "تم تقديم الطلب بنجاح!",
    insuranceOn: "تم تفعيل التأمين",
    insuranceOff: "تم إلغاء تفعيل التأمين",
    operationFailed: "فشلت العملية",
    balanceFetchFailed: "فشل في الحصول على الرصيد",
    minAmount: "الحد الأدنى للمبلغ هو 0.1 TAKER",
    insufficientBalance: "رصيد غير كافٍ، الرصيد الحالي: {balance} TAKER",
    createFailed: "فشل في إنشاء المركز",
    recoverTitle: "Recover pending order",
    recoverContent: "Unconfirmed order found ({symbol} {direction} {amount}). Will reuse the original idempotency key without requoting.",
    recoverConfirm: "Recover",
    recoverCancel: "Cancel"
  },
  appeal: {
    title: "مساعدة مراجعة الأصول",
    records: "سجلات الإرسال",
    recordsTitle: "سجلات الإرسال",
    noRecords: "لا توجد سجلات إرسال",
    submitTime: "وقت الإرسال",
    statusPending: "قيد المعالجة",
    statusApproved: "تمت الموافقة",
    statusRejected: "مرفوض",
    failedReason: "سبب الرفض",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "جارٍ التحميل...",
    walletAddress: "العنوان المرتبط بـ PANTA MARKET",
    address: "العنوان",
    walletAddressPlaceholder: "أدخل عنوان تسجيل الدخول إلى PANTA MARKET",
    autoFill: "ملء تلقائي",
    depositAmount: "مبلغ الإيداع",
    depositAmountPlaceholder: "أدخل مبلغ الإيداع",
    tokenType: "نوع الرمز",
    selectToken: "اختر الرمز",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "وقت التحويل",
    selectTime: "اختر وقت التحويل",
    timeRangeHint: "البيانات ذات الصلة الناتجة بين 5 مارس 2026 الساعة 00:00 و11 مارس الساعة 10:00 (SGT).",
    txHash: "HASH / TXID",
    txHashPlaceholder: "أدخل تجزئة المعاملة",
    txHashHint: "يمكن الاستعلام عنها في مستكشف البلوكشين",
    uploadImages: "لقطة شاشة لسجل التحويل",
    uploadHint: "اختياري، قم بتحميل ما يصل إلى 9 صور",
    addImage: "إضافة صورة",
    submit: "إرسال",
    submitting: "جارٍ الإرسال...",
    submitSuccess: "تم الإرسال بنجاح",
    submitFailed: "فشل الإرسال، يرجى المحاولة مرة أخرى",
    uploadingImages: "جارٍ تحميل الصور...",
    uploadImagesFailed: "فشل تحميل الصور",
    warningTitle: "إشعار مهم",
    warningText: "إذا تم التحقق من السجل المقدم بنجاح، ستحصل على مكافأة بنسبة 5٪ من قوة الاشتراك. إذا تم تقديم معلومات كاذبة، فسيتم تجميد الحساب."
  },
  withdrawSheet: {
    title: "سحب",
    balance: "الرصيد",
    processing: "جاري سحب TAKER...",
    success: "تم سحب TAKER بنجاح!",
    withdrawing: " جاري السحب...",
    withdrawSuccess: " تم الإرسال للمراجعة",
    recordBadge: "Withdraw Record",
    sheetTitle: "Withdraw {token}",
    sheetDesc: "Enter the amount to withdraw. Minimum {min} USDT. No fees.",
    available: "Available {token}",
    amountPlaceholder: "Enter amount (min {min} USDT)"
  },
  depositSheet: {
    title: "إيداع TAKER",
    depositTo: "إيداع إلى",
    spotAccount: "حساب فوري",
    network: "الشبكة",
    networkWarning: "يتم دعم الإيداعات عبر شبكة BSC/BEP20 فقط. لا يمكن استرداد خسائر الأصول الناتجة عن استخدام شبكات أخرى.",
    depositAddress: "عنوان الإيداع",
    address: "العنوان",
    depositTAKER: "إيداع TAKER",
    recharge: "إعادة الشحن",
    rechargeAddress: "عنوان إعادة الشحن",
    copy: "نسخ",
    copySuccess: "تم النسخ بنجاح",
    loadingAddress: "جاري الحصول على عنوان إعادة الشحن...",
    loadAddressFailed: "فشل الحصول على عنوان إعادة الشحن",
    clickToRetry: "انقر لإعادة المحاولة",
    saveAndShare: "حفظ ومشاركة العنوان",
    generating: "جاري الإنشاء...",
    generateSuccess: "تم الإنشاء بنجاح",
    generateFailed: "فشل الإنشاء",
    more: "المزيد",
    save: "حفظ",
    wechat: "WeChat",
    recordBadge: "Deposit Record",
    sheetDesc: "Deposit {token} from your wallet to platform balance",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "الصورة المحفوظة",
    download: "تحميل",
    pleaseGenerate: "يرجى إنشاء الصورة أولاً",
    downloadSuccess: "تم التحميل بنجاح",
    saveSuccess: "تم الحفظ بنجاح",
    saveFailed: "فشل الحفظ",
    needPermission: "يلزم الإذن لحفظ الصورة في الألبوم",
    pleaseUseDapp: "يرجى استخدام المحفظة لفتح عملية dapp",
    claimDesc: "Transfer USDT to the deposit address, then paste the tx hash to claim",
    claimButton: "Claim Deposit",
    environment: "Environment",
    txHash: "Transaction Hash",
    txHashPlaceholder: "Paste 0x transaction hash",
    optionalAmount: "Amount (optional note)"
  },
  sidebar: {
    loginAccount: "دعوة الأصدقاء وكسب عمولات الفريق",
    inviteBanner: "دعوة الأصدقاء وكسب عمولات الفريق",
    inviteCode: "رمز الدعوة",
    defaultName: "PANTA MARKET",
    logoutWallet: "Disconnect Wallet"
  },
  teamDetails: {
    myReferrals: "إحالاتي",
    currentLevel: "المستوى الحالي: {level}",
    nextLevel: "المستوى التالي",
    totalMembers: "الإحالات المباشرة",
    validMembers: "الأعضاء الصالحون",
    teamLevel: "مستوى الفريق: {level}",
    tradeTeam: "فريق التداول",
    financeTeam: "فريق التمويل",
    teamMembers: "أعضاء الفريق",
    teamData: "Team Data",
    teamEarningsJoule: "Team Earnings (WATT)",
    myCurrentLevel: "My level: {level}",
    currentTotalPerf: "Total performance: {value}",
    currentAreaPerf: "Area performance: {value}",
    inviteDetails: "Invite details",
    startDate: "Start date",
    dateTo: "to",
    endDate: "End date",
    editRemark: "Edit note",
    addRemark: "Add note",
    viewDetail: "View details",
    status: "Status: ",
    time: "Time: ",
    level: "Level: ",
    inviteType: "Invite type: ",
    viewTeam: "View team",
    communityValidCount: "Community actives: ",
    communityTotalPerf: "Community volume: ",
    areaTotalPerf: "Area volume: ",
    yesterdayStake: "Yesterday stake: ",
    communityMaxLevel: "Community top level: ",
    personalEquity: "Personal equity: ",
    remarkPlaceholder: "Enter a note",
    saveRemark: "Update",
    filterAll: "All",
    filterDirect: "Direct",
    filterIndirect: "Indirect",
    viewingIndirect: "{name}'s directs",
    teamPowerUsdt: "Team Power (USDT)",
    teamFlowJoule: "Team Volume (WATT)",
    statusInvalid: "Inactive",
    statusValid: "Active",
    peopleUnit: "{n}",
    remarkSaved: "Note saved"
  },
  teamMemberModal: {
    totalProfit: "إجمالي الربح",
    totalFlow: "إجمالي التدفق",
    totalInvites: "إجمالي الدعوات",
    validMembers: "إجمالي الأعضاء الصالحين"
  },
  fundRecords: {
    feeLabel: "Fee: {fee}",
    withdrawTitle: "Withdraw Records",
    exchangeTitle: "Exchange Records",
    depositTitle: "Deposit Records"
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "محادثة جديدة",
    manual: "Manual",
    manualCardTitle: "Open operation manual",
    manualCardDesc: "Illustrated steps for deposit, exchange, transfer, and AI prediction",
    hello: "مرحباً، أنا مساعدك بالذكاء الاصطناعي",
    hint: "اسأل عن الأسواق، أين قواعد تأمين الحدث/AI، الفريق والدعوة، أو المخاطر.",
    placeholder: "اسأل شيئاً...",
    send: "إرسال",
    thinking: "جارٍ التحليل...",
    disclaimer: "للمرجع فقط — وليست نصيحة استثمارية.",
    bullish: "صعود",
    bearish: "هبوط",
    aiAnalysis: "ملخص AI",
    strategy: "استراتيجية",
    reasoning: "الاستدلال",
    targetPrice: "الهدف {price}",
    stopLoss: "وقف {price}",
    takeProfit: "جني {price}",
    dirLong: "Long",
    dirShort: "Short",
    dirNeutral: "محايد",
    analysisDone: "اكتمل تحليل {symbol} ({timeframe}). انظر البطاقة أدناه.",
    analysisBtc: "تحليل قصير الأجل لـ BTC.",
    analysisEth: "تحليل نطاق ETH.",
    analysisRisk: "قراءة مخاطر السوق.",
    suggestions: {
      btc1m: "حلّل نظرة BTCUSDT لـ 1 دقيقة",
      ethTrend: "هل ألحق ETH أم أنتظر؟",
      marketRisk: "ما شهية المخاطر الحالية؟",
      eventRules: "أين أرى ملخص قواعد تأمين عقد الحدث؟",
      aiRules: "كيف أفهم قواعد/مستويات تنبؤ AI؟",
      teamWhere: "أين أرى تفاصيل الفريق؟",
      inviteWhere: "أين رابط الدعوة / ربط الأعلى؟"
    },
    guides: {
      eventRules: "قواعد تأمين الحدث: افتح Event Contract ثم مدخل القواعد بجانب مفتاح التأمين. الملخص للأقساط/الحدود/المنافع؛ الاتفاقية الكاملة للنص الرسمي.",
      aiRules: "AI Prediction: التبويب الأوسط → AI Prediction. راجع العدّ التنازلي للجولة التالية ومستوى/خطوة التأمين وحصص التنبؤ الذاتي. القواعد في ورقة التأمين نفسها. يجب أن يطابق الطلب حجم المستوى والاتجاه.",
      teamWhere: "تفاصيل الفريق: الشريط الجانبي أو أنا → فريقي. بدّل أرباح التداول/التمويل ثم تفاصيل الفريق للإحالات المباشرة والحجم والمستوى والأعضاء.",
      inviteWhere: "الدعوة والربط: الشريط/أنا → دعوة الأصدقاء لنسخ الرابط (?ref=). إن لم يُربَط الأعلى تظهر نافذة بعد تسجيل الدخول. بلا معامل دعوة يُملأ الحقل بعنوان افتراضي من النظام."
    },
    generic: {
      a: "تم. اسأل عن الأسواق أو مواقع قواعد الحدث/AI أو الفريق والدعوة، أو اضغط الاختصارات.",
      b: "حسناً. بطاقات التوقعات وإرشادات الميزات.",
      c: "جرّب اختصارات قواعد الحدث وAI وتفاصيل الفريق ورابط الدعوة."
    }
  },
  createMarket: {
    title: "Create Market",
    saveDraft: "Save Draft",
    marketTitle: "Market Title",
    titlePlaceholder: "Enter market title",
    category: "Category",
    secondaryOptional: "Secondary (opt.)",
    deadline: "Deadline",
    optionsTitle: "Outcomes (2–16)",
    optionsSub: "Name each option",
    resetDefault: "Reset",
    addOption: "+ Add Option",
    ratioHint: "Initial ratio: leave blank to split evenly; if filled, each option needs an integer 1–99 and the total must be 100.",
    rulesSection: "Rules / Settlement Source",
    rulesSectionSub: "Optional — shown in the rules & settlement popup on the detail page",
    rulesLabel: "Rules",
    rulesPlaceholder: "Settlement criteria, edge cases, etc.",
    settleLabel: "Settlement Source",
    settlePlaceholder: "Official site / news / URL",
    liquidityTitle: "Initial Liquidity",
    liquiditySub: "Funds needed to bootstrap the market",
    enabled: "On",
    disabled: "Off",
    investAmount: "Amount (JOULE)",
    balance: "Balance: {n}",
    max: "Max",
    initialLiquidity: "Initial Liquidity",
    marginRefund: "Margin (refunded after settlement)",
    totalTip: "Margin matches liquidity 1:1 and is fully refunded when the event settles or is canceled.",
    totalDeduct: "Total Deduct",
    feeTip: "Tip: you earn a 0.5% creator fee on every trade in this market.",
    accessPassword: "Access Password",
    accessPasswordSub: "The event will show a lock. Only people with the share link or password can enter.",
    passwordPlaceholder: "Set password (4–20 chars)",
    hide: "Hide",
    show: "Show",
    cardPreview: "Card Preview",
    deadlinePrefix: "Ends {date}",
    submitting: "Creating...",
    submit: "Confirm & Add Liquidity",
    createSuccess: "Created",
    creating: "Creating",
    creatingDesc: "Please wait while we submit the market…",
    backHome: "Home",
    createAnother: "Create Another",
    deadlineShort: "{m}/{d}",
    yes: "Yes",
    no: "No",
    optionN: "Option {n}",
    draftSaved: "Draft saved",
    draftSaveFailed: "Failed to save draft",
    resetDone: "Reset to defaults",
    maxOptions: "Up to 16 options",
    minOptions: "Keep at least 2 options",
    needMinOptions: "Need at least 2 options",
    fillOptionName: "Enter a name for option {n}",
    fillAllPercents: "Fill a ratio for every option",
    percentRange: "Ratios must be integers 1–99",
    percentSum: "Ratios must sum to 100 (now {sum})",
    enterTitle: "Enter a market title",
    enterAmount: "Enter an amount",
    insufficientBalance: "Insufficient balance (incl. margin)",
    passwordLength: "Password must be 4–20 characters",
    deadlineFuture: "Deadline must be in the future",
    completeForm: "Please complete the form",
    createdMsg: "“{title}” created. Ends {date} {time}"
  },
  marketDetail: {
    tabTrades: "صفقات حديثة",
    tabLp: "LP",
    tabPositions: "مراكز",
    tabRules: "القواعد",
    colAddress: "العنوان",
    colTime: "الوقت",
    colType: "النوع",
    colVolumePrice: "الحجم/السعر",
    colTurnover: "القيمة",
    typeBuy: "شراء",
    typeSell: "بيع",
    empty: "لا بيانات",
    share: "مشاركة",
    rulesBody: "هذا سوق توقع حدث ثنائي. قد يُقفل دفتر الأوامر قبل التسوية، وبعد إعلان النتيجة تتم التسوية حسب الحصة. يرجى الانتباه للمخاطر.",
    priceJoule: "السعر (JOULE)",
    investJoule: "الاستثمار (JOULE)",
    totalLiquidity: "السيولة",
    dealPrice: "سعر التنفيذ",
    estProfit: "ربح تقديري",
    jouleBalance: "رصيد JOULE: {n}",
    positionCount: "عدد المراكز: {n}",
    max: "أقصى",
    confirmOrder: "تأكيد الطلب",
    ordering: "جارٍ الإرسال...",
    enterAmount: "أدخل المبلغ",
    invalidPrice: "سعر غير صالح",
    amountExceed: "تجاوز الرصيد",
    orderSuccess: "تم الطلب",
    poolSize: "حجم المجمع",
    colBalance: "الرصيد",
    shares: "{n} وحدة",
    rulesTitle: "شرح القواعد",
    rulesValue: "لا وصف بعد",
    settleSource: "مصدر التسوية",
    settleValue: "لا وصف بعد"
  },
  rank: {
    applyTitle: "Become an Expert",
    applyDesc: "Show your trading talent and earn revenue share",
    applyCta: "Join Now",
    tabExpert: "Expert Ranking",
    tabMaker: "Market Maker",
    tabWinRate: "Win Rate",
    tabProfit: "Profit",
    experts: {
      trendCatcher: "Trend Catcher",
      whaleWatcher: "Whale Watcher",
      cryptoWolf: "Crypto Wolf",
      swingCaptain: "Swing Captain",
      arbHunter: "Arb Hunter",
      bullKnight: "Bull Knight"
    },
    tagPolitics: "Politics",
    tagEsports: "Esports",
    comingSoon: "Coming soon"
  },
  operationManual: {
    title: "Operation Manual",
    docTitle: "PANTA MARKET Operation Manual",
    sourceHint: "Illustrated steps adapted from the official manual. Tap screenshots to zoom."
  },
  pantaMarket: {
    title: "Panta Market",
    tokenSection: "رمز حوكمة PANTA",
    todayBurn: "المحروق اليوم",
    totalBurn: "إجمالي المحروق",
    burned: "محروق",
    initialSupply: "الإصدار الأولي",
    maxSupply: "أقصى إصدار",
    finalCirculation: "التداول النهائي",
    contractAddress: "العقد: ",
    copied: "تم النسخ",
    ecoSection: "PANTA · منظومة الذكاء الاصطناعي",
    ecoTabs: {
      market: "تحليل السوق",
      arbitrage: "أدوات المراجحة",
      acquisition: "اكتساب عالمي",
      video: "إنتاج الفيديو"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA · مجموعات إبداعية",
    groupTabs: {
      recommend: "لك",
      hot: "الأكثر رواجًا",
      ipDrama: "دراما IP",
      ipCollab: "إبداع مشترك IP",
      data: "بيانات"
    },
    filters: {
      all: "الكل",
      new: "إصدارات جديدة",
      ending: "ينتهي قريبًا",
      highScore: "تقييم ذكاء اصطناعي مرتفع"
    },
    project: {
      badge: "العرض الأول على الكوكب",
      title: "《Panta AI · النهوض》 فيلم رسوم متحركة قصير بالذكاء الاصطناعي",
      score: "تقييم الذكاء الاصطناعي 92",
      tagDrama: "دراما IP",
      tagRights: "حقوق #0001",
      desc: "Panta AI يساعدني على قلب المعادلة — دراما قصيرة لتعليم تطبيقات الذكاء الاصطناعي"
    },
    values: {
      todayBurn: "321",
      totalBurn: "4,212",
      initialSupply: "10M",
      maxSupply: "210M",
      finalCirculation: "21M"
    }
  },
  copyTrade: {
    menuTitle: "نسخ التداول",
    pageTitle: "نسخ التداول",
    fallback: "فشلت العملية. يرجى المحاولة لاحقًا.",
    pauseRule: "إذا كنت لا تزال في حالة إيقاف مؤقت عند اكتمال تسوية هذا الأسبوع، سيتم إلغاء علاقة النسخ تلقائيًا الأسبوع القادم.",
    pauseSuccess: "تم الإيقاف المؤقت بنجاح",
    resumeSuccess: "تم الاستئناف",
    endSuccess: "تم الإنهاء",
    followSuccess: "بدأ النسخ",
    pendingReviewToast: "بانتظار مراجعة المتداول",
    savedSuccess: "تم الحفظ",
    registerSuccess: "تم التسجيل. تم تجميد الوديعة.",
    cancelRequested: "تم طلب الإلغاء",
    cancelWithdrawn: "تم سحب طلب الإلغاء",
    kickedSuccess: "تمت الإزالة",
    approvedSuccess: "تمت الموافقة",
    rejectedSuccess: "تم الرفض",
    filledToForm: "تم التعبئة في نموذج المتابعة",
    traderNotFound: {
      search: "المتداول غير موجود. تحقق من عنوان المحفظة، أو ربما لم يفعّل نسخ التداول بعد.",
      business: "هذا المتداول غير متاح حاليًا"
    },
    tabs: {
      board: "لوحة المتصدرين",
      follows: "متابعاتي",
      join: "متابعة",
      trader: "قيادة",
      apps: "الطلبات",
      fans: "المتابعون",
      rules: "القواعد",
      settings: "القواعد",
      follow: "متابعة"
    },
    ui: {
      refresh: "تحديث",
      search: "بحث",
      loginWallet: "ربط المحفظة",
      needLoginAction: "يتطلب هذا الإجراء تسجيل الدخول بالمحفظة، مثل وضع الطلبات.",
      needLoginTrader: "واجهات المتداول تتطلب تسجيل الدخول.",
      loginToView: "سجّل الدخول للعرض",
      loading: "جارٍ التحميل…",
      empty: "لا يوجد",
      readonly: "للقراءة فقط",
      yes: "نعم",
      no: "لا",
      immediate: "ساري فورًا",
      current: "الحالي",
      nextWeek: "الأسبوع القادم",
      pause: "إيقاف مؤقت",
      resume: "استئناف",
      end: "إنهاء",
      save: "حفظ",
      kick: "إزالة",
      approve: "موافقة",
      reject: "رفض",
      requestCancel: "طلب الإلغاء",
      withdrawCancel: "سحب طلب الإلغاء",
      confirmFollow: "تأكيد المتابعة",
      registerWithDeposit: "تجميد الوديعة والتسجيل",
      registerConfirmTitle: "Confirm registration",
      registerFreezeConfirm: "{amount} JOULE margin will be frozen in the trading account.",
      platformSettings: "إعدادات المنصة",
      settingsTip: "يتم نسخ أوامر القيادة العادية المؤمّنة فقط. الأوامر العادية غير المؤمّنة وأوامر AI لا تُنسخ، والأوامر COPY المُنشأة لا تؤدي إلى نسخ إضافي. يستخدم المتداولون واجهة الأوامر الحالية ولا يجب تمرير orderSource. يرى المتابعون أوامر COPY في القائمة. المبالغ تعرض منزلتين عشريتين؛ الباقي يُقطع.",
      deposit: "الوديعة",
      depositFreezeWeeks: "أسابيع تجميد الوديعة",
      maxFollowers: "حد المتابعين",
      shareRateRange: "نطاق نسبة المشاركة",
      shareRateDefault: "نسبة المشاركة الافتراضية",
      shareRateNextWeek: "نسبة المشاركة تسري الأسبوع القادم",
      pendingShareHint: "يسري الاثنين القادم: {rate}",
      pendingMaxFollowersHint: "يسري الاثنين القادم: {n}",
      depositFrozenShort: "ما زال مجمداً",
      minFollowStake: "الحد الأدنى لرأس مال المتابعة",
      ratioRange: "نطاق النسبة",
      maxSimultaneousFollows: "الحد الأقصى للمتابعات المتزامنة",
      defaultReview: "المراجعة الافتراضية",
      defaultMinBalance: "حد الرصيد الافتراضي",
      settlementTimezone: "المنطقة الزمنية للتسوية",
      leaderboardMeta: "الحد الأدنى للوحة / الحجم",
      leaderboardMetaValue: "{min} أوامر / {size} صفوف",
      weekLeaderboard: "لوحة نسبة الفوز هذا الأسبوع",
      expertLeaderboard: "لوحة المتداولين",
      heroTitle: "كن متداولًا قائدًا",
      heroDesc: "ابدأ قيادة الصفقات واكسب حصة من الأرباح",
      heroActiveTitle: "أنت متداول قائد",
      heroActiveDesc: "حالة المتداول القائد نشطة",
      heroRegister: "تسجيل",
      heroSettings: "إعدادات القيادة",
      myLeading: "قيادتي",
      winRateBoard: "نسبة الفوز",
      pnlBoard: "الربح",
      searchAddress: "بحث العنوان",
      searchNicknameOrAddress: "ابحث عن اللقب أو العنوان",
      searchQueryTooShort: "أدخل حرفين على الأقل",
      winRateShort: "نسبة الفوز",
      followersLabel: "المتابعون:",
      shareRateLabel: "نسبة المشاركة:",
      roundPnlLabel: "ربح/خسارة الجولة:",
      settledOrders: "تمت تسوية {n}",
      activeCount: "قيد التنفيذ",
      followStatsShort: "المجمع {pool} · محجوز {cash}",
      traderSettings: "إعدادات القيادة",
      confirmChanges: "تأكيد التغييرات",
      confirmCancel: "تأكيد الإلغاء",
      cancelModalTitle: "إشعار الإلغاء",
      activeInProgress: "قيد التنفيذ",
      leadingFollowerCount: "المتابعون {n}",
      auditApps: "الطلبات {n}",
      leaderboardNote: "يُحسب فقط أوامر الفوز/الخسارة العادية المؤمّنة المُسوّاة هذا الأسبوع بعد الحد الأدنى للأوامر. ليست نسبة الفوز التاريخية ولا AI. لا يُوفّر اسم الفريق وحجم المتابعة التراكمي.",
      weekStart: "بداية الأسبوع (الإثنين): {date}",
      leaderboardEmpty: "لا يوجد متداولون في اللوحة بعد. ابحث بالعنوان الكامل للمتابعة.",
      winRate: "فوز {n}%",
      boardSub: "مشاركة {share} · متابعون {followers}/{max} · مُسوّاة {orders} · ر/خ أسبوعي {pnl} JOULE",
      searchTrader: "بحث متداول",
      walletPlaceholder: "عنوان المحفظة الكامل 0x…",
      address: "العنوان",
      status: "الحالة",
      shareRate: "نسبة المشاركة",
      review: "مراجعة",
      minBalance: "حد الرصيد",
      followerCount: "المتابعون",
      startFollow: "بدء المتابعة",
      traderWallet: "عنوان المتداول",
      followMode: "وضع المتابعة",
      ratioLabel: "النسبة (%)، النطاق {min} ~ {max}",
      insuranceMode: "وضع التأمين",
      takeProfit: "جني الأرباح (JOULE، اختياري)",
      stopLoss: "وقف الخسارة (JOULE، اختياري)",
      takeProfitPh: "إيقاف مؤقت عند بلوغ صافي الربح/الخسارة الأسبوعي",
      stopLossPh: "إيقاف مؤقت عند بلوغ صافي الخسارة الأسبوعي",
      followHint: "يمكنك متابعة {n} متداول كحد أقصى في آن واحد. عند الوصول للحد، متابعة متداول جديد تنهي العلاقة الحالية أولًا — وليست معاينة بلا تأثير. لتغيير المعلمات، أنهِ ثم تابع مجددًا.",
      endConfirm:
        "إنهاء علاقة النسخ مع هذا المتداول؟ لن تتابع إشاراته بعد ذلك. الأوامر التاريخية وPnL المسوّى غير متأثرين.",
      weeklyPoolHint: "المجمع لهذا الأسبوع وليس حجم المتابعة التراكمي. العلاقات المنتهية والطلبات المعلقة ليست في هذه القائمة.",
      networkUnclear: "النتيجة غير مؤكدة. حدّث وتحقق من العلاقة الحالية أو ملف المتداول قبل إعادة المحاولة.",
      myFollows: "متابعاتي",
      noFollows: "لا توجد علاقات متابعة",
      followSub: "{mode}{ratio} · {insurance} · مشاركة مقفلة {share}",
      followStats: "ر/خ أسبوعي {pnl} · المجمع {pool} · محجوز {cash}",
      pauseReason: "سبب الإيقاف: {reason}",
      registerTrader: "التسجيل كمتداول",
      registerHint: "التسجيل: ادفع {amount} JOULE كوديعة متداول قائد (مجمدة أثناء النشاط؛ تُسترد بعد مراجعة الإلغاء). هوية متداول واحدة لكل محفظة.",
      registerBalanceHint: "بعد تجميد وديعة {deposit} JOULE، يجب أن يبقى الرصيد المتاح ≥ {remain} JOULE.",
      shareRateInput: "نسبة المشاركة (%) النطاق {min} ~ {max}؛ التغييرات في الدورة التالية.",
      maxFollowersInput: "حد المتابعين (≤ {max})",
      reviewMode: "طريقة الموافقة",
      minBalanceInput: "حد رصيد المتابع · اختياري (JOULE)",
      myTrader: "ملفي كمتداول",
      depositHeld: "{amount} / مجمد {held}",
      currentFollowers: "المتابعون الحاليون",
      cancelEffective: "الإلغاء يسري في",
      depositRelease: "إطلاق الوديعة في",
      editParams: "تعديل الإعدادات",
      editHint: "المشاركة/الحد تسري الأسبوع القادم؛ المراجعة والحد فورًا. قفل التسوية الأحد 22:00 حتى قبل الإثنين 01:00 (SGT). اعتمد على الخادم؛ لا تستأنف التعديل يوم الإثنين 00:00 بنفسك.",
      shareRatePercent: "نسبة المشاركة (%)",
      minBalanceJoule: "حد الرصيد (JOULE)",
      cancelTip: "بعد الإلغاء ما زلت تقود هذا الأسبوع؛ الهوية تنتهي الإثنين القادم 00:00؛ الوديعة تبقى مجمدة أسبوعًا إضافيًا ثم تُعاد. يمكن السحب قبل السريان.",
      followers: "المتابعون",
      followerSub: "{mode}{ratio} · ر/خ أسبوعي {pnl} · محجوز {cash}",
      applications: "الطلبات المعلقة",
      noApplications: "لا توجد طلبات",
      fillForm: "تعبئة نموذج المتابعة",
      needTraderFirst: "سجّل كمتداول أولًا",
      cancelRequestedAt: "طُلب الإلغاء في",
      ratioRangeInvalid: "يجب أن تكون النسبة بين {min} و {max}",
      shareRangeInvalid: "يجب أن تكون نسبة المشاركة بين {min} و {max}",
      maxFollowersInvalid: "حد المتابعين لا يمكن أن يتجاوز {max}",
      needShareRate: "أدخل نسبة المشاركة",
      needMaxFollowers: "أدخل حد المتابعين",
      needRatio: "أدخل النسبة",
      badTakeProfit: "مبلغ جني الأرباح غير صالح",
      badStopLoss: "مبلغ وقف الخسارة غير صالح",
      badMinBalance: "حد الرصيد غير صالح",
      insuranceShortFollow: "متابعة",
      insuranceShortOn: "دائمًا مفعّل",
      insuranceShortOff: "دائمًا معطّل",
      symbolSettings: "إعدادات رموز النسخ",
      symbolPickHint: "الكل معطّل افتراضيًا؛ فعّل يدويًا، قابل للتعديل في أي وقت",
      followSymbolHint: "اختر من الرموز التي يسمح بها هذا المتداول. فعّل واحدًا على الأقل.",
      followSymbolWait: "ابحث عن متداول أولًا، ثم اختر الرموز للمتابعة.",
      symbolNeedOne: "فعّل رمزًا واحدًا على الأقل",
      symbolNotAllowed: "رمز محدد غير مسموح به من هذا المتداول",
      effectiveSymbols: "الفعّالة",
      editSymbols: "تعديل الرموز",
      allowedSymbols: "الرموز المفتوحة",
      weekPnlLabel: "ربح/خسارة الأسبوع:",
      currentNetPnlLabel: "Current Net PnL",
      categoryCrypto: "عملات رقمية",
      categoryCommodity: "سلع",
      categoryEquity: "أسهم",
      symbolListCol: "القائمة",
      symbolLeadCol: "قيادة",
      symbolFollowCol: "متابعة",
      symbolTags: "مفتوح",
      leadingSymbols: "رموز القيادة",
      detail: "التفاصيل",
      enabled: "مفعّل",
      disabled: "معطّل",
      held: "مفتوح",
      notHeld: "مغلق",
      weekSettledOrders: "مُسوّاة هذا الأسبوع",
      historicalNetPnl: "إجمالي ر/خ",
      copyTotalPnl: "إجمالي ربح/خسارة النسخ",
      historicalSharePayout: "مدفوعات المشاركة",
      allOrders: "الكل",
      prevPage: "Prev",
      nextPage: "Next",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Go to",
      jumpConfirm: "Go",
      openOrders: "مفتوحة",
      settledOrdersTab: "مُسوّاة",
      colInterval: "المدة",
      colOrderTime: "وقت الأمر",
      colSelfPnl: "ر/خ الذاتي (شامل القسط)",
      colEstShare: "مشاركة تقديرية (JOULE)",
      traderOrdersTitle: "أوامر قيادة {symbol}",
      followOrdersTitle: "أوامر نسخ {symbol}",
      selfPnl: "ر/خ الذاتي",
      estimatedShare: "مشاركة تقديرية",
      inProgress: "قيد التنفيذ",
      followAssets: "ر/خ حسب الأصل",
      byAsset: "حسب الأصل",
      followHistory: "منتهية",
      followStartTime: "البداية: ",
      followEndTime: "النهاية: ",
      myPendingApps: "معلق",
      cashHeldHint: "مشاركة تقديرية محجوزة هذا الأسبوع {cash} JOULE",
      cashHeldFrozen: "خصم مشاركة تقديري هذه الجولة: {cash} (JOULE، مجمد)",
      followedTrader: "المتداول",
      followInfo: "معلومات المتابعة",
      totalPnlJoule: "إجمالي ر/خ (JOULE)",
      colTrader: "المتداول",
      colPrincipal: "أصل",
      colPnlShare: "ر/خ (شامل القسط) / مشاركة (JOULE)",
      traderInfo: "ملف المتداول",
      traderNotFound: "المتداول غير موجود",
      followSettingsRelationHint: "وضع المتابعة والتأمين ووقف الربح/الخسارة ينطبق على العلاقة بالكامل وجميع الرموز المحددة. يمكنك تعديلها في أي وقت من إعدادات المتابعة.",
      followSettingsPrepareHint: "بعد التأكيد، ستُستخدم إعدادات المتابعة هذه لجميع الرموز المحددة.",
      followOptions: "خيارات المتابعة",
      noFollowOptions: "لا توجد خيارات متابعة~",
      symbolFollowing: "يتم المتابعة",
      symbolPaused: "موقوف مؤقتًا",
      symbolIdle: "غير متابع",
      cancelFollowSymbol: "إلغاء المتابعة",
      cancelSymbolConfirm: "إيقاف متابعة {symbol}؟",
      cancelLastSymbolConfirm: "هذا آخر رمز. إلغاء المتابعة سينهي العلاقة بالكامل. متابعة؟",
      followNow: "متابعة الآن",
      followAll: "متابعة",
      unfollowAll: "إلغاء المتابعة",
      unfollowAllConfirm: "إيقاف متابعة جميع رموز هذا المتداول؟ سينهي علاقة النسخ بالكامل.",
      followSettings: "إعدادات المتابعة",
      goFollowSettings: "فتح ›",
      copyAccountBalance: "حساب النسخ: {amount} JOULE",
      orderFollowerCount: "عدد المتابعين لهذا الأمر",
      copyingStatus: "جارٍ النسخ",
      roleStatusLeading: "يقود الصفقات",
      roleStatusFollowing: "يتبع الصفقات",
      roleStatusPaused: "التابع متوقف",
      copyOrderTag: "نسخ",
      copyOpenPositions: "مراكز النسخ المفتوحة",
      copyInsuredOrdinary: "تأمين عادي مفعّل",
      copyUninsured: "بدون تأمين",
      addSymbolHint: "سيُضاف هذا الرمز إلى متابعتك الحالية.",
      myRelationStatus: "متابعتي",
      latestSettlements: "أحدث التسويات",
      resumeRelationFirst: "العلاقة موقوفة بالكامل. استأنفها في متابعاتي قبل إجراءات الرموز.",
      resumeStopLossHint: "Current weekly loss is {amount}. Set stop-loss above {amount} to resume copying.",
      resumeTakeProfitHint: "Current weekly profit is {amount}. Set take-profit above {amount} to resume copying.",
      resumeStartFollow: "Start following",
      colType: "النوع",
      colPnlJoule: "ر/خ (JOULE)",
      tpSl: "جني الأرباح / وقف الخسارة",
      takeProfitPhFull: "إيقاف مؤقت بعد صافي الربح الأسبوعي — اختياري (JOULE)",
      stopLossPhFull: "إيقاف مؤقت بعد صافي الخسارة الأسبوعي — اختياري (JOULE)",
      confirmModify: "تأكيد",
      clearSearch: "العودة للوحة",
      searchResultHint: "نتائج البحث (اضغط لفتح ملف المتداول)",
      searchEmpty: "المتداول غير موجود",
      noMoreSettlements: "لا المزيد"
    },
    errors: {
      AUTH_REQUIRED: "يرجى ربط المحفظة أولًا",
      AUTH_UNAVAILABLE: "خدمة تسجيل الدخول غير متاحة مؤقتًا. حاول لاحقًا.",
      POSTGRES_REQUIRED: "الخدمة غير متاحة مؤقتًا. حاول لاحقًا.",
      USER_NOT_FOUND: "المستخدم غير موجود. سجّل الدخول مجددًا وحاول.",
      INVALID_WALLET: "أدخل عنوان محفظة كامل",
      INVALID_QUERY: "استعلام غير صالح؛ أدخل حرفين على الأقل",
      INVALID_AMOUNT: "تنسيق المبلغ غير صالح",
      INVALID_PARAM: "معلمات غير صالحة. تحقق وحاول مجددًا.",
      INVALID_FOLLOW: "لا يمكنك نسخ صفقاتك",
      TRADER_EXISTS: "هذه المحفظة متداول بالفعل. لا حاجة للتسجيل مجددًا.",
      TRADER_FULL: "وصل هذا المتداول لحد المتابعين",
      TRADER_CANCELLED: "تم إلغاء حساب هذا المتداول",
      TRADER_REGISTER_FAILED: "فشل التسجيل كمتداول. حاول لاحقًا.",
      TRADER_SETTINGS_FAILED: "فشل حفظ إعدادات المتداول. حاول لاحقًا.",
      NOT_A_TRADER: "Register as a trader first",
      TRADER_UNAVAILABLE: "This trader is currently unavailable",
      INSUFFICIENT_BALANCE: "الرصيد المتاح غير كافٍ لتجميد الوديعة",
      BALANCE_TOO_LOW: "رصيد حساب النسخ أقل من حد هذا المتداول. حوّل من حساب التداول أولاً",
      COPY_BALANCE_ZERO: "رصيد حساب النسخ هو 0. حوّل من حساب التداول أولاً",
      INSUFFICIENT_FUNDS: "رصيد حساب التداول غير كافٍ للتحويل إلى حساب النسخ",
      COPY_TRADE_BALANCE_INSUFFICIENT: "الرصيد المتاح في حساب النسخ غير كافٍ (لا يمكن سحب المجمد)",
      ACCOUNT_NOT_FOUND: "خطأ في الحساب. حاول لاحقًا.",
      ACCOUNT_CONFLICT: "الحساب قيد التحديث. حاول لاحقًا.",
      FOLLOW_EXISTS: "أنت تتابع هذا المتداول بالفعل",
      FOLLOW_LIMIT: "لديك علاقة نسخ نشطة. أنهِها قبل متابعة متداول آخر.",
      FOLLOW_FAILED: "فشل بدء النسخ. حاول لاحقًا.",
      FOLLOW_NOT_FOUND: "علاقة النسخ غير موجودة",
      PAUSE_FAILED: "فشل إيقاف النسخ مؤقتًا. حاول لاحقًا.",
      RESUME_FAILED: "فشل استئناف النسخ. حاول لاحقًا.",
      STOP_LOSS_THRESHOLD: "Stop-loss is still too low. Raise or clear it, then resume.",
      TAKE_PROFIT_THRESHOLD: "Take-profit is still too low. Raise or clear it, then resume.",
      END_FAILED: "فشل إنهاء النسخ. حاول لاحقًا.",
      APPLICATION_NOT_FOUND: "الطلب المعلق غير موجود",
      APPROVE_FAILED: "فشلت الموافقة على الطلب. حاول لاحقًا.",
      REJECT_FAILED: "فشل رفض الطلب. حاول لاحقًا.",
      KICK_FAILED: "فشلت إزالة المتابع. حاول لاحقًا.",
      SETTLEMENT_WINDOW: "لا يمكن تغيير إعدادات المتداول أثناء نافذة التسوية",
      CANCEL_FAILED: "فشل طلب الإلغاء. حاول لاحقًا.",
      CANCEL_NOT_PENDING: "لا يوجد طلب إلغاء لسحبه",
      CANCEL_WITHDRAW_FAILED: "فشل سحب طلب الإلغاء. حاول لاحقًا.",
      COPY_SETTINGS_MISSING: "إعدادات نسخ التداول غير جاهزة. حاول لاحقًا.",
      INVALID_SYMBOL: "اختر رمزًا مدعومًا واحدًا على الأقل",
      SYMBOL_NOT_ALLOWED: "يتضمن رمزًا لا يسمح به هذا المتداول",
      TRADER_BALANCE_TOO_LOW: "الرصيد المتاح بعد تجميد الوديعة منخفض جدًا للتسجيل",
      TIMEOUT: "فشلت العملية. حاول لاحقًا.",
      NETWORK: "فشلت العملية. حاول لاحقًا."
    },
    status: {
      ACTIVE: "نشط",
      PAUSED: "موقوف مؤقتًا",
      ENDED: "منتهٍ",
      PENDING_REVIEW: "بانتظار مراجعة المتداول",
      CANCEL_PENDING: "إلغاء معلق",
      CANCELLED: "ملغى"
    },
    traderStatus: {
      ACTIVE: "يقود",
      CANCEL_PENDING: "يخرج",
      CANCELLED: "ملغى",
    },
    pauseReason: {
      USER: "إيقاف من المستخدم",
      INSUFFICIENT_BALANCE: "متوقف: رصيد حساب النسخ غير كافٍ",
      TAKE_PROFIT: "تفعيل جني الأرباح",
      STOP_LOSS: "تفعيل وقف الخسارة",
      TRADER_KICK: "أزاله المتداول",
      SWITCH: "تبديل المتداول",
      SETTLEMENT_CLEANUP: "أُزيل عند التسوية الأسبوعية",
      TRADER_CANCEL: "ألغى المتداول"
    },
    followMode: {
      EQUAL: "مبلغ متساوٍ",
      RATIO: "نسبة"
    },
    insuranceMode: {
      FOLLOW: "متابعة المتداول",
      ALWAYS_ON: "دائمًا مفعّل",
      ALWAYS_OFF: "دائمًا معطّل"
    },
    reviewMode: {
      AUTO: "متابعة تلقائية",
      MANUAL: "متابعة بمراجعة"
    },
    applicationStatus: {
      PENDING: "معلق",
      APPROVED: "موافق عليه",
      REJECTED: "مرفوض",
      CANCELLED: "ملغى",
      PENDING_REVIEW: "معلق"
    }
  },}
